<template>
  <div>
    <r-badge class="badge-filtros" v-if="mostrarBadgeFiltros()" v-noroles="['ENAC', 'PRODUCCION']" color="red" :text="getTextFiltrosActivos()"></r-badge>
    <!-- <span v-if="tiempoCarga">Tiempo de carga: {{ tiempoCarga | numberFormat(2, ',', '') }} seg</span>
    <span v-if="tiempoCargaSumatorios">Tiempo de carga sumatorios: {{ tiempoCargaSumatorios | numberFormat(2, ',', '') }} seg</span> -->
    <!-- <slot name="before" :rlist="self"></slot> -->
    <f7-card-header v-if="tipoConsultasEstaticas || self.tableUse && !(self.tableUse && self.tableUse.opciones && self.tableUse.opciones.hiddenHeader)">
      <div class="data-table-header" v-if="Object.keys(selected).length==0">
        <div class="data-table-links width-100">
          <slot name="tableLinks" :rlist="self"></slot>
          <r-form class="margin-left" v-if="tableUse || tipoConsultasEstaticas" ref="rformConsultas"
            :defaultData="{
              consulta: getConsultaDefecto()
            }"
          >
            <template v-slot="{rform}">
              <div v-if="tipoConsultasEstaticas" class="data-table-actions" >
                <f7-list 
                  no-hairlines-md 
                >
                  <r-autocomplete
                    ref="consultas"
                    :dbAdapter="Tabla"
                    floating-label
                    outline
                    :label="$t('common.consultasComandos')"
                    :form="rform"
                    name="consultaComando"
                    idProp="codigo"
                    labelProp="nombre"
                    :clearButton="true"
                    @change="changeTable(rform.formData.consultaComando, massiveActions)"
                    class="consulta-autocomplete"
                    :shownFields="['tipo']"
                    :filter="{filter: {tipo: tipoConsultasEstaticas}}"
                  ></r-autocomplete>
                </f7-list>
                <f7-button v-if="tableUse && tipoConsultasEstaticas && tableUse.prefiltros && tableUse.prefiltros.length" button fill @click="popupPrefiltrosOpened = true" class="display-flex" icon-f7="square_pencil">{{$t('common.cambiarFiltros')}}</f7-button>
              </div>
              <div v-else-if="vistaActual !== 'MAPA'" class="data-table-actions" >
                <f7-list
                  v-if="!!self.tableUse" :class="{display_none:(self.tableUse && self.tableUse.opciones && self.tableUse.opciones.hiddenFavoritesQueries) || ignoreTableFilters}"
                  no-hairlines-md
                  class="consultas-list"
                >
                  <!-- Sin la "x" de borrar: en su sitio van los tres puntos, que agrupan guardar,
                       eliminar, compartir y borrar contenido (ver popover-consultas). -->
                  <r-autocomplete
                    ref="consultasCombo"
                    floating-label
                    outline
                    :label="$t('common.consultasFavoritas')"
                    :dbItems="tableUse.consultasFavoritas"
                    :form="rform"
                    name="consulta"
                    :idProp="null"
                    labelProp="nombre"
                    :clearButton="false"
                    @change="changeConsulta(rform.formData.consulta)"
                    class="consulta-autocomplete consulta-con-menu"
                  >
                    <template v-slot:inner-end>
                      <f7-link
                        class="input-suffix-btn consultas-menu-trigger"
                        icon-f7="ellipsis_vertical"
                        @click="abrirMenuConsultas($event)"
                        @mouseenter.native="abrirMenuConsultas($event)"
                      ></f7-link>
                    </template>
                  </r-autocomplete>
                </f7-list>
              </div>
            </template>
          </r-form>
          <div v-if="vistaActual === 'MAPA' && hasMapFilterColumns()" class="data-table-actions map-filters-actions margin-left">
            <r-form
              ref="rformMapFilters"
              :defaultData="mapFilterConditions"
              @submit="applyMapFilters($event)"
            >
              <template v-slot="{rform}">
                <div class="map-filters-compact">
                  <div
                    v-for="column in getMapFilterColumns()"
                    :key="'map-filter-' + getFiltroPathName(column)"
                    class="map-filter-chip"
                    :class="{ 'map-filter-chip-active': isMapFilterColumnActive(column) }"
                  >
                    <span class="map-filter-chip-label" v-tooltip="$t(column.nombre)">{{ $t(column.nombre) }}</span>
                    <f7-link
                      small
                      icon-material="filter_list"
                      class="pointer map-filter-chip-icon"
                      :class="{ 'map-filter-chip-icon-active': isMapFilterColumnActive(column) }"
                      v-tooltip="$t('common.filtrar')"
                      @click.stop="$f7.popover.get('[map-filter-pathname=\'' + getFiltroPathName(column) + '\']').open($event.target)"
                    >
                      <f7-popover
                        class="map-filter-popover"
                        :closeByBackdropClick="false"
                        :backdrop="false"
                        closeOnEscape
                        :map-filter-pathname="getFiltroPathName(column)"
                        style="width: 360px; max-width: calc(100vw - 32px);"
                      >
                        <f7-navbar :title="$t('common.filtro')">
                          <f7-nav-right>
                            <f7-link popover-close icon-f7="multiply"></f7-link>
                          </f7-nav-right>
                        </f7-navbar>
                        <div class="map-filter-popover-content">
                          <f7-list no-hairlines-md class="map-filter-popover-list">
                            <r-list-filter-item
                              :ref="'map-filter-item-' + getFiltroPathName(column)"
                              :column="column"
                              :form="rform"
                              :viewTooltip="false"
                              @keyup.enter.native="applyMapFilters(rform.formData)"
                            ></r-list-filter-item>
                          </f7-list>
                        </div>
                      </f7-popover>
                    </f7-link>
                    <f7-link
                      v-if="isMapFilterColumnActive(column)"
                      small
                      icon-f7="multiply_circle_fill"
                      class="pointer map-filter-chip-clear"
                      v-tooltip="$t('common.borrarFiltro')"
                      @click.stop="removeMapFilter(column)"
                    ></f7-link>
                  </div>
                  <f7-link small @click="applyMapFilters(rform.formData)" icon-f7="search" v-tooltip="$t('common.buscar')"></f7-link>
                  <f7-link small @click="clearMapFilters()" icon-f7="bin_xmark" v-tooltip="$t('common.cleanFilter')"></f7-link>
                </div>
              </template>
            </r-form>
          </div>
          <f7-list v-if="vistaActual !== 'MAPA'" no-hairlines-md class="margin-left">
            <f7-list-input
              v-if="!(self.tableUse && self.tableUse.opciones && self.tableUse.opciones.hiddenFiltrarColumnas)"
              @change="searchColumns=$event.target.value"
              autocomplete="no"
              label="Filtrar Columnas"
              floating-label
              outline
              :clearButton="true"
            >
            </f7-list-input>
          </f7-list>
        </div>
        <div v-if="(!tipoConsultasEstaticas || (tipoConsultasEstaticas && tableUse)) && !(self.tableUse && self.tableUse.opciones && self.tableUse.opciones.hiddenTopButtons)" class="data-table-actions">
          <slot name="extendedActions" :selecteds="!selected"></slot>
          <template v-if="tableUse && tipoConsultasEstaticas && tableUse.ejecutores && tableUse.ejecutores.length">
            <f7-button
              v-for="(ejecutor, idxEjecutor) in tableUse.ejecutores"
              :key="'ejecutor-' + idxEjecutor"
              small fill
              :style="ejecutor.color ? ('background-color: ' + ejecutor.color + ';') : ''"
              class="display-flex"
              @click="activarEjecutor(ejecutor)"
            >{{$t(ejecutor.nombre)}}</f7-button>
            <f7-button v-if="ejecutorActivo" small outline class="display-flex" @click="desactivarEjecutor()">{{$t('common.cancelar')}}</f7-button>
          </template>
          <span class="separator"></span>
          <f7-link
            small
            color="green"
            @click="sendToSAP=true; submitFilterForm()"
            icon-f7="dog"
            v-tooltip="'Guau Guau'"
            v-if="Utils.getUser() && Utils.getUser().username == 'SIMECAL'"
          ></f7-link>
          <f7-link
            ref="btnSearchFilterFormHeader"
            small
            @click="submitFilterForm"
            icon-f7="search"
            v-tooltip="$t('common.buscar')"
            v-if="filterPosition == 'HEADER' && (!tipoConsultasEstaticas || !tableUse || !tableUse.prefiltros || !tableUse.prefiltros.length)"
          ></f7-link>
          <f7-link
            small
            @click="$refs.rformfilterHeader.clear()"
            icon-f7="bin_xmark"
            v-tooltip="$t('common.cleanFilter')"
            v-if="filterPosition == 'HEADER' && (!tipoConsultasEstaticas || !tableUse || !tableUse.prefiltros || !tableUse.prefiltros.length)"
          ></f7-link>
          <f7-link small @click="reload()" icon-f7="arrow_counterclockwise" v-tooltip="$t('common.actualizarTabla')"></f7-link>
          <f7-link v-if="self.tableUse && self.tableUse.opciones && self.tableUse.opciones.exportarExcel" small @click="exportExcel(tableUse.nombre + '.xlsx')" icon-f7="doc_text_fill" v-tooltip="$t('common.exportarExcel')"></f7-link>
          <!-- En móvil la columna de controles no existe: el engranaje de columnas vive aquí. -->
          <f7-link v-if="accionesPorFila() && !tipoConsultasEstaticas && !(tableUse && tableUse.opciones && tableUse.opciones.hiddenConfigColumns)" small @click="$refs.popoverColumnas.open($event.target)" icon-f7="gear_alt_fill" v-tooltip="$t('common.configurarColumnas')"></f7-link>
          <f7-segmented v-if="self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa && self.tableUse.opciones.mapa.habilitado" strong class="margin-left">
            <f7-button :active="vistaActual === 'LISTADO'" @click="vistaActual = 'LISTADO'" icon-f7="list_bullet">Listado</f7-button>
            <f7-button :active="vistaActual === 'MAPA'" @click="vistaActual = 'MAPA'" icon-f7="map">Mapa</f7-button>
          </f7-segmented>
          <!-- Combo para seleccionar dirección en el mapa -->
          <div v-if="vistaActual === 'MAPA' && self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa && Array.isArray(self.tableUse.opciones.mapa.direcciones) && self.tableUse.opciones.mapa.direcciones.length > 1" class="margin-left map-direction-select">
            <select
              :value="selectedMapDirection"
              @change="selectedMapDirection = parseInt($event.target.value)"
              class="input-with-value"
              style="height: 29px; border-radius: 4px; border: 1px solid #c8c7cc; padding: 0 8px;"
            >
              <option v-for="(dir, idx) in self.tableUse.opciones.mapa.direcciones" :key="idx" :value="idx">
                {{ dir.titulo }}
              </option>
            </select>
          </div>
          <f7-link
            small
            @click="$refs.rpanel.toggle()"
            icon-f7="line_horizontal_3_decrease"
            v-show="!rPanelOpenedByBreakpoint"
            v-if="filterPosition == 'PANEL'"
          ></f7-link>
        </div>
      </div>
      <div class="data-table-header-selected display-flex" v-else>
        <!-- Selected table title -->
        <div class="data-table-title-selected">
          <span
            class="data-table-selected-count"
          >{{$tc('rlist.n_registros_seleccionados', Object.keys(selected).length, {count:Object.keys(selected).length}) }}</span>
        </div>
        <!-- Selected table actions -->
        <div class="data-table-actions">
          <f7-button v-if="massiveActionsData && getActiveColumnsMasivo().length" class="display-flex" @click="abrirCambioMasivo()" fill icon-f7="pencil_ellipsis_rectangle">{{$t('common.cambiosmasivos')}}</f7-button>
          <slot name="massiveActions" :selecteds="selected"></slot>
        </div>
      </div>
    </f7-card-header>
    
    <!-- <div :class="classContent" :style="(!tableUse || (tableUse && tableUse.opciones && tableUse.opciones.hiddenList))?'display: none;':''"> -->
    <div :class="classContent" v-show="vistaActual === 'LISTADO' && (tipoConsultasEstaticas || (tableUse && tableUse.opciones && !tableUse.opciones.hiddenList))">
      <slot name="beforeInner" :rlist="self"></slot>
      <r-form 
        ref="rformfilterHeader"
        @submit="setFilter($event);"
        :filtersName="filtersName"
        class="full-height table-content"
        :defaultData="mandatoryFilter"
        classContent="full-height"
        @scroll="listScroll($event)"
      >
        <template v-slot="{rform}">
          <div v-if="tableMode" class="dynamic-list width-100" ref="dl">
            <div class="dynamic-list-content" :style="styleWidthLinea()">
              <div class="thead-sticky">
                <div class="line" :style="styleWidthLinea()">
                  <div class="cell checkbox-cell left-column-sticky sticky" :style="`width: ${widthCheckColumn}px;`">
                    <label class="checkbox" v-if="(massiveActionsSelectAll && count) || (massiveActionsData && count)">
                      <input type="checkbox" @change="toggleSelectAll($event.target.checked)" />
                      <i class="icon-checkbox"></i>
                    </label>
                    <label v-else-if="massiveActionsData">
                      <div @click="toggleSelectAll()">
                        <f7-icon 
                          class="pointer"
                          v-if="Object.keys(selected).length" 
                          f7="clear_fill" 
                          :title="$t('common.desmarcarSeleccionados')"
                        ></f7-icon>
                      </div>
                    </label>
                  </div>
                  <div
                    v-for="(header, idx) in getColumnsFiltered()" :key="'header-' + header.pathName + '-' + idx"
                    :style="'min-width:1em; background-color: ' + header.bgColor + ';' + styleWidthCelda(header)"
                    @click="!header.disableOrder ? setOrder(header.pathName) : 'nada'"
                    :class="customHeaderClasses(header)"
                    class="cell"
                    v-tooltip="$t(header.nombre)"
                  >
                  <f7-link 
                    v-if="filterPosition == 'HEADER' && header.filtro && header.filtro.activo && (!header.filtro.opciones || !header.filtro.opciones.hidden)" 
                    small icon-f7="multiply_circle_fill" class="pointer filter-icon-delete" 
                    v-tooltip="$t('common.borrarFiltro')" 
                    @click.stop="removeFilter(header)"
                  >
                  </f7-link>
                  <f7-link 
                    v-if="filterPosition == 'HEADER' && header.filtro && header.filtro.activo && (!header.filtro.opciones || !header.filtro.opciones.hidden)" 
                    small icon-material="filter_list" class="pointer filter-icon" 
                    v-tooltip="$t('common.filtrar')" 
                    @click.stop="$f7.popover.get('[pathname=\'' + header.pathName + '\']').open($event.target)"
                  >
                    <f7-popover 
                      :closeByBackdropClick="false" 
                      :backdrop="false" 
                      closeOnEscape
                      :pathname="header.pathName"
                    >
                      <f7-navbar :title="$t('common.filtro')">
                        <f7-nav-right>
                          <f7-link popover-close icon-f7="multiply"></f7-link>
                        </f7-nav-right>
                      </f7-navbar>
                      <f7-list no-hairlines-md>
                        <r-list-filter-item
                          :column="header"
                          :form="rform"
                          :viewTooltip="false"
                          :ref="'header-item-' + header.pathName"
                          @keyup.enter.native="onPressEnter"
                        >
                        </r-list-filter-item>
                      </f7-list>
                    </f7-popover>
                  </f7-link>
                  {{$t(header.nombre)}}
                  </div>
                  <div v-if="!tipoConsultasEstaticas && !(tableUse && tableUse.opciones && tableUse.opciones.hiddenConfigColumns) && !accionesPorFila()" :style="'width: '+anchoControles()+'px'" class="cell label-cell text-align-center right-column-sticky controls-cell" @click="$refs.popoverColumnas.open($event.target)">
                    <f7-link icon-f7="gear_alt_fill" class="pointer" v-tooltip="$t('common.configurarColumnas')" ></f7-link>
                  </div>
                </div>
              </div>
              <!-- <slot name="header" :rlist="self"></slot> -->
              <div class="ptr-content" :style="styleWidthLinea()">
                <div class="ptr-preloader" style="position:absolute;">
                  <div class="preloader"></div>
                  <div class="ptr-arrow"></div>
                </div>
              </div>
              <div class="contenido-lista">
                <template v-if="!searched && !loadingInfinite">
                  <div colspan="100%" :style="`height:${vlData.topPosition}px`"></div>
                  <div colspan="100%">
                    <div v-if="tipoConsultasEstaticas" colspan="100%" class="cell text-align-center">{{$t('common.firstSearchTipoEstatico')}}</div>
                    <div v-else colspan="100%" class="cell text-align-center">{{$t('common.firstSearch')}}</div>
                  </div>
                </template>
                <template v-else-if="!count && !loadingInfinite && !loadingAggregations">
                  <div colspan="100%" :style="`height:${vlData.topPosition}px`"></div>
                  <div colspan="100%">
                    <div colspan="100%" class="cell text-align-center">{{$t('common.noResults')}}</div>
                  </div>
                </template>
                <template v-else>
                  <div colspan="100%" :style="`height:${vlData.topPosition}px`"></div>
                  <!-- Items -->
                    <div v-for="(item) in vlData.items" class="line" :key="(tableUse?tableUse.codigo:'UNDEFINED') + getPrimary(item)" @click="clickFila(item, $event)" :class="{trclicked : itemClicked == getPrimary(item)}"  :style="styleWidthLinea()+customLineStyle(item)">
                      <div class="cell checkbox-cell left-column-sticky sticky" :style="`width: ${widthCheckColumn}px;`">
                        <label class="checkbox" v-if="mostrarCheck(item)">
                          <input
                            type="checkbox"
                            :checked="getPrimary(item) in selected"
                            @change="toggleSelect(item, $event.target.checked)"
                          />
                          <i class="icon-checkbox"></i>
                        </label>
                      </div>
                      <div
                        v-for="(column) in getColumnsFiltered()" :key="'column-' + column.pathName"
                        :style="'background-color: ' + column.bgColor + ';' + styleWidthCelda(column)"
                        :class="customColumnClasses(column)"
                        class="cell"
                      >
                        <template v-if="$scopedSlots['column-' + column.pathName]">
                          <slot :name="'column-' + column.pathName" :item="item" :column="column" :rlist="self"></slot>
                        </template>

                        <template v-else-if="column.tipo == 'FECHA' || column.tipo == 'FECHAHORA'">
                          <div :title="cellText(item, column)">
                            {{cellText(item, column)}}
                          </div>
                        </template>
                        <template v-else-if="column.tipo == 'BADGE'">
                          <r-badge v-if="getValorItem(item, column)" :color="getColorItem(item, column)" :text="(getValorItem(item, column) || column.valorVacio) + (column.sufijo || '')"></r-badge>
                          <template v-else>{{column.valorVacio}}</template>
                        </template>
                        <template v-else-if="column.tipo == 'BOOLEAN'">
                          <r-badge v-if="cellText(item, column) != ''" :color="getValorItem(item, column) ? 'green' : 'red'" :text="cellText(item, column)"></r-badge>
                          <template v-else>{{column.valorVacio}}</template>
                        </template>
                        <template v-else-if="column.tipo == 'NUMERO'">
                          <div :title="cellText(item, column)">
                            {{cellText(item, column)}}
                          </div>
                        </template>
                        <template v-else-if="column.tipo == 'LISTA'">
                          <f7-link v-if="!getValorItem(item, column)" class="badge color-red"> 
                            {{$t('common.sin')}} {{$t(column.nombre)}}
                          </f7-link>
                          <f7-link v-else class="badge color-green pointer" @click="abrirPopupListado(item, column)">
                            {{itemStringify(item, column)?itemStringify(item, column):$t('common.ver') + ' ' + $t(column.nombre)}} ({{getValorItem(item, column).length}})
                          </f7-link>
                        </template>
                        <template v-else-if="column.tipo == 'COMENTARIO'">
                          <div class="columnaComentario" v-tooltip="(getValorItem(item, column) || column.valorVacio) + ' ' + (column.sufijo || '') ">{{getValorItem(item, column) || column.valorVacio}} {{column.sufijo || ''}}</div>
                        </template>
                        <template v-else-if="column.tipo == 'HTML' || column.tipo == 'OBJETO'">
                          <div
                            v-tooltip="(((column.opciones && column.opciones.evalPathName) ? getValorItem(item, column) : formatearValorObjeto(item, column)) || column.valorVacio) + (column.sufijo || '')"
                            v-html="(((column.opciones && column.opciones.evalPathName) ? getValorItem(item, column) : formatearValorObjeto(item, column)) || column.valorVacio) + (column.sufijo || '')"
                          ></div>
                        </template>
                        <template v-else-if="column.tipo == 'PUNTO'">
                          <div class="columnaPunto" v-noroles="['ENAC', 'PRODUCCION']">
                            <f7-link
                              v-if="getValorItem(item, column) && getValorItem(item, column).latitud != null && getValorItem(item, column).longitud != null && column.opciones"
                              :href="'https://maps.google.com/?q='+getValorItem(item, column).latitud+','+getValorItem(item, column).longitud"
                              icon-f7="map_pin_ellipse"
                              color="brown"
                              external
                              v-tooltip="getValorItem(item, column).direccion"
                              :text="column.opciones.mostrarDireccion ? getValorItem(item, column).direccion : null"
                            ></f7-link>
                            <span v-else>{{column.valorVacio}}</span>
                          </div>
                          <div class="columnaPunto" v-roles="['ENAC', 'PRODUCCION']">
                            <span v-if="getValorItem(item, column) && getValorItem(item, column).latitud != null && getValorItem(item, column).longitud != null && column.opciones"
                              v-tooltip="getValorItem(item, column).latitud+','+getValorItem(item, column).longitud"
                              style="font-size: 10px;"
                            >{{ getValorItem(item, column).latitud+','+getValorItem(item, column).longitud }}</span>
                            <span v-else>{{column.valorVacio}}</span>
                          </div>
                        </template>
                        <template v-else>
                          <div :title="(getValorItem(item, column) || column.valorVacio) + ' ' + (column.sufijo || '')">
                            {{getValorItem(item, column) || column.valorVacio}} {{column.sufijo || ''}}
                            <f7-link
                              v-if="getValorItem(item, column) && column.opciones && column.opciones.url"
                              style="float:right;"
                              :href="column.opciones.url + getValor(item, column.opciones.campoId) + '/'"
                              icon-f7="arrow_up_right_square"
                              color="green"
                              external
                              v-tooltip="'Navegar a seleccionado'"
                            ></f7-link>
                          </div>
                        </template>
                      </div>
                      <!-- En móvil (acciones por fila) la columna de controles ni se pinta: las acciones
                           se abren tocando la fila (ver clickFila) y el engranaje sube a la cabecera. -->
                      <div v-show="!accionesPorFila()" class="cell text-align-right right-column-sticky controls-cell" :style="'width: '+anchoControles()+'px'">
                        <!-- Acciones de la línea: en tablet y móvil se agrupan en un solo icono que las
                             despliega (rAccionesAgrupadas); en pantallas grandes van sueltas. -->
                        <r-acciones-agrupadas
                          v-if="$scopedSlots.optionsColumn"
                          :ref="'acciones-' + getPrimary(item)"
                          :agrupar="agruparAcciones"
                          :sinIcono="accionesPorFila()"
                          ancla=".line"
                        >
                          <slot name="optionsColumn" :item="item" :rlist="self"></slot>
                        </r-acciones-agrupadas>
                      </div>
                    </div>
                </template>
                <div
                  :style="`height:${vlData.listHeight-vlData.topPosition-(vlData.toIndex-vlData.fromIndex)*vlParams.height}px`"
                >
                  <div class="cell" colspan="100%" style="height:0px;padding:0!important;">
                    <div
                      v-show="loadingInfinite && !loadingPtr"
                      class="preloader infinite-scroll-preloader"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-else>
            <slot name="header" :rlist="self"></slot>
            <div class="ptr-preloader">
              <div class="preloader"></div>
              <div class="ptr-arrow"></div>
            </div>
            <ul class="ptr-content">
              <div :style="`height:${vlData.topPosition}px`"></div>
              <slot :vlData="vlData" :rlist="self"></slot>
              <div
                :style="`height:${vlData.listHeight-vlData.topPosition-(vlData.toIndex-vlData.fromIndex)*vlParams.height}px`"
              >
                <div
                  v-show="loadingInfinite && !loadingPtr"
                  class="preloader infinite-scroll-preloader"
                ></div>
              </div>
            </ul>
          </template>
          <slot v-if="!loadingPtr&&!loadingInfinite&&!vlData.items.length" name="empty"></slot>
        </template>
      </r-form>
      <!-- Filtros -->
      <rPanel
        ref="rpanel"
        side="right"
        @openedByBreakpoint="rPanelOpenedByBreakpoint=true"
        @closedByBreakpoint="rPanelOpenedByBreakpoint=false"
        v-slot="{rpanel}"
        v-if="filterPosition == 'PANEL'"
      >
        <r-form 
          ref="rformfilter"
          @submit="setFilter($event); rpanel.close();"
          :filtersName="filtersName"
          :defaultData="mandatoryFilter"
        >
          <template v-slot:before="{rform}">
            <f7-toolbar>
              <div>{{$t('common.filtro')}}</div>
              <f7-link icon-f7="bin_xmark" @click="rform.clear();" v-tooltip="$t('common.cleanFilter')"></f7-link>
            </f7-toolbar>
          </template>
          <template v-slot="{rform}">
            <f7-list no-hairlines-md>
              <r-list-filter-item
                v-for="column in getActiveColumnsFiltro()" 
                :key="'column-filtro-' + getFiltroPathName(column)"
                :column="column"
                :form="rform"
                @keyup.enter.native="onPressEnter"
              ></r-list-filter-item>
              <f7-button ref="btnSearchFilterForm" button type="submit" class="margin-vertical" icon-f7="search">Buscar</f7-button>
            </f7-list>
          </template>
        </r-form>
      </rPanel>
    </div>

    <!-- Vista de Mapa -->
    <div v-if="vistaActual === 'MAPA' && self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa && self.tableUse.opciones.mapa.habilitado" style="position: relative; padding: 0; margin: 0; min-height: calc(100vh - 200px); overflow: hidden;">
      <div v-if="loadingMapData" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; background: rgba(255,255,255,0.9); z-index: 999;">
        <div style="text-align: center;">
          <f7-preloader></f7-preloader>
          <p>Cargando todos los registros del mapa...</p>
        </div>
      </div>
      <r-map-view
        :items="mapFilteredData"
        :mapConfig="self.tableUse.opciones.mapa"
        :selectedDirectionIndex="selectedMapDirection"
        :columns="columns"
        :popupActionsRenderer="popupActionsRenderer"
        @map-action="$emit('map-action', $event)"
      ></r-map-view>
    </div>

    <f7-card-footer>
      <span v-if="!loadingAggregations">
        <b>{{$tc('rlist.n_registros', count, {count: count})}}</b>
      </span>
      <div class="aggregation-div">
        <f7-row class="row-aggregation margin-left">
          <div
            v-if="loadingAggregations"
            class="preloader infinite-scroll-preloader color-black"
          >
            <span class="preloader-inner">
              <span class="preloader-inner-circle"></span>
            </span>
          </div>
          <div
            v-else
            v-for="agregacion in getActiveAgregaciones()"
            :key="'agregacion-' + agregacion.as"
            class="col-aggregation"
            :class="getClassesAgregaciones()"
            :style="agregacion.opciones?agregacion.opciones.style:''"
          >
            <!-- <b v-if="agregacion.opciones && agregacion.opciones.evalPathName">{{$t(agregacion.nombre)}} <sup class="subindice" v-if="agregacion.conCount">({{getAgregacionCount(agregacion) || 0 | numberFormat(0, ',', '.')}})</sup>: {{getAgregacionValor(agregacion) || agregacion.valorVacio | numberFormat(agregacion.formato, ',', '.')}}  {{agregacion.sufijo || ''}}</b> -->
            <b>{{$t(agregacion.nombre)}} <sup class="subindice" v-if="agregacion.conCount">({{getAgregacionCount(agregacion) || 0 | numberFormat(0, ',', '.')}})</sup>: {{getAgregacionValor(agregacion) || agregacion.valorVacio | numberFormat(agregacion.formato, ',', '.')}}  {{agregacion.sufijo || ''}}</b>
          </div>
        </f7-row>
      </div>
      <span v-if="!(tableUse && tableUse.opciones && tableUse.opciones.hiddenConfigurarAgregaciones) && !tipoConsultasEstaticas" style="width:7em;" class="label-cell" @click="$refs.popoverAgregaciones.open($event.target)">
        <f7-link icon-f7="gear_alt_fill" class="pointer" v-tooltip="$t('common.configurarAgregaciones')" ></f7-link>
      </span>
    </f7-card-footer>

    <!-- Menú de la consulta favorita: lo que antes eran tres iconos sueltos más la "x" del combo. -->
    <f7-popover ref="popoverConsultas" class="popover-consultas" :backdrop="false" closeOnEscape style="width: 230px;" @popover:close="consultasMenuCerradoEn = Date.now()">
      <f7-list no-hairlines>
        <f7-list-item link="#" popover-close popup-open=".popup-guardar-consulta" :title="$t('common.guardar')">
          <f7-icon slot="media" f7="floppy_disk"></f7-icon>
        </f7-list-item>
        <f7-list-item link="#" popover-close :title="$t('common.eliminar')" @click="deleteConsulta($refs.rformConsultas.formData.consulta)">
          <f7-icon slot="media" f7="trash"></f7-icon>
        </f7-list-item>
        <f7-list-item link="#" popover-close popup-open=".popup-shared-consulta" :title="$t('common.compartir')">
          <f7-icon slot="media" f7="person_3_fill"></f7-icon>
        </f7-list-item>
        <f7-list-item link="#" popover-close :title="$t('common.borrarContenido')" @click="$refs.consultasCombo.setValue({})">
          <f7-icon slot="media" f7="multiply_circle"></f7-icon>
        </f7-list-item>
      </f7-list>
    </f7-popover>

    <f7-popover :closeByBackdropClick="false" :backdrop="false" closeOnEscape ref="popoverColumnas" @popover:closed="forceUpdate()" style="width: 250px;">
      <f7-navbar :title="$t('common.configurarColumnas')">
        <f7-nav-right>
          <f7-link popover-close icon-f7="multiply"></f7-link> 
        </f7-nav-right>
      </f7-navbar>
      <f7-list class="list-columnas">
        <f7-list-input
          :value="searcherConfigColumns" @input="searcherConfigColumns = $event.target.value"
        >
        </f7-list-input>
        <f7-list-item
          checkbox
          title="Todas"
          name="todas-columnas"
          :checked="getActiveColumns().length === columns.length"
          :indeterminate="getActiveColumns().length !== columns.length"
          @change="onConfigColumnsAllChange"
        >
          <ul slot="root" class="padding-left-half">
            <Container
              @drop="onDrop(columns, $event)"
              lock-axis="y"
              style="z-index: 12000;"
            >
              <Draggable
                v-for="(columna, idx) in getSearcherConfigColumns(columns)"
                :key="'columna-config-' + idx"
              >
                <f7-list-item
                  checkbox
                  :value="columna.pathName"
                  name="todas-columnas"
                  :checked="columna.activaUsuario"
                  :title="$t(columna.nombre)"
                  :style="columna.bgColor ? 'background-color: ' + columna.bgColor + ';' : null"
                  @change="columna.activaUsuario = $event.target.checked; clearAll();"
                ></f7-list-item>
              </Draggable>
            </Container>
          </ul>
        </f7-list-item>
      </f7-list>
      <f7-button
        fill
        icon-f7="floppy_disk"
        :text="$t('common.aceptar')"
        class="display-flex margin"
        @click="(self.tableUse && self.tableUse.opciones && self.tableUse.opciones.autosave) ? guardarConsulta($refs.rformConsultas.formData.consulta.nombre) : '';"
        popover-close
      ></f7-button>
    </f7-popover>
    <f7-popover :closeByBackdropClick="false" :backdrop="false" closeOnEscape ref="popoverAgregaciones" @popover:closed="forceUpdate()" style="width: 250px;">
      <f7-navbar :title="$t('common.configurarAgregaciones')">
        <f7-nav-right>
          <f7-link popover-close icon-f7="multiply"></f7-link> 
        </f7-nav-right>
      </f7-navbar>
      <f7-list class="list-columnas">
        <f7-list-item
          checkbox
          title="Todas"
          name="todas-agregaciones"
          :checked="getActiveAgregaciones().length === agregaciones.length"
          :indeterminate="getActiveAgregaciones().length !== agregaciones.length"
          @change="onConfigAgregacionesAllChange"
        >
          <ul slot="root" class="padding-left-half">
            <Container
              @drop="onDrop(agregaciones, $event)"
              lock-axis="y"
              style="z-index: 12000;"
            >
              <Draggable
                v-for="(agregacion, idx) in agregaciones"
                :key="'agregacion-config-' + idx"
              >
                <f7-list-item
                  checkbox
                  :value="agregacion.as"
                  name="todas-agregaciones"
                  :checked="agregacion.activaUsuario"
                  :title="$t(agregacion.nombre)"
                  @change="agregacion.activaUsuario = $event.target.checked; clearAll();"
                ></f7-list-item>
              </Draggable>
            </Container>
          </ul>
        </f7-list-item>
      </f7-list>
      <f7-button
        fill
        icon-f7="floppy_disk"
        :text="$t('common.aceptar')"
        class="display-flex margin"
        popover-close
      ></f7-button>
    </f7-popover>

    <f7-popup ref="popupGuardarConsulta" class="popup-guardar-consulta" @popup:open="$refs.rformGuardarConsulta.loadFilters( {nombreConsulta: $refs.rformConsultas.formData.consulta.nombre || ''})">
      <f7-navbar :title="$t('common.guardarConsulta')">
        <f7-nav-right>
        </f7-nav-right>
      </f7-navbar>
      <r-form ref="rformGuardarConsulta">
        <template v-slot="{rform}">
          <f7-list no-hairlines-md>
            <r-input
              floating-label
              outline
              :label="$t('common.nombre')"
              :form="rform"
              name="nombreConsulta"
              :clearButton="true"
            ></r-input>
            <f7-button
              fill
              icon-f7="floppy_disk"
              :text="$t('common.guardar')"
              class="display-flex margin"
              @click="guardarConsulta(rform.formData.nombreConsulta)"
            ></f7-button>
          </f7-list>
        </template>
      </r-form>
    </f7-popup>

    <f7-popup ref="popupCambioMasivo" v-if="popupCambioMasivoOpened" :opened="true" @popup:closed="popupCambioMasivoOpened = false">
      <f7-navbar :title="$t('common.cambiosmasivos')">
        <f7-nav-right>
        </f7-nav-right>
      </f7-navbar>
      <r-form 
        ref="rformCambioMasivo"
        @submit="cambioMasivo($event);"
      >
        <template v-slot="{rform}">
          <f7-list no-hairlines-md class="popupHeight">
            <!-- Conmutador discreto entre "Todo a la vez" (clásico) y "Progresivo" (SSE por lotes
                 con progreso y ETA). Arranca con lo declarado en el listado (showProgress). -->
            <div class="margin-horizontal margin-top display-flex justify-content-flex-end align-items-center" style="font-size: 12px; opacity: 0.85;">
              <span class="margin-right-half">{{ modoProgresivo ? 'Progresivo' : 'Todo a la vez' }}</span>
              <f7-toggle :checked="modoProgresivo" @toggle:change="modoProgresivo = $event"></f7-toggle>
            </div>
            <div class="margin display-flex flex-direction-column">
              <f7-button fill color="green" @click="cambioMasivoProgress(rform.formData)" icon-f7="chart_bar_circle" v-if="modoProgresivo">
                {{$t('common.actualizarMasivamente')}} (Progresivo)
              </f7-button>
              <f7-button fill type="submit" icon-f7="pencil_outline" class="margin-top" v-if="!modoProgresivo">
                {{$t('common.actualizarMasivamente')}} (Todo a la vez)
              </f7-button>
            </div>
            <r-list-filter-item
              v-for="column in getActiveColumnsMasivo()"
              :key="'column-masivo-' + getFiltroPathName(column)"
              :column="column"
              :form="rform"
              tipo="MASIVO"
            ></r-list-filter-item>
            <div class="margin display-flex flex-direction-column">
              <f7-button fill color="green" @click="cambioMasivoProgress(rform.formData)" icon-f7="chart_bar_circle" v-if="modoProgresivo">
                {{$t('common.actualizarMasivamente')}} (Progresivo)
              </f7-button>
              <f7-button fill type="submit" icon-f7="pencil_outline" class="margin-top" v-if="!modoProgresivo">
                {{$t('common.actualizarMasivamente')}} (Todo a la vez)
              </f7-button>
            </div>
          </f7-list>
        </template>
      </r-form>
    </f7-popup>

    <f7-popup ref="popupPrefiltros" v-if="popupPrefiltrosOpened" :opened="true" @popup:closed="popupPrefiltrosOpened = false">
      <f7-navbar :title="$t('common.buscar')">
        <f7-nav-right>
        </f7-nav-right>
      </f7-navbar>
      <r-form 
        ref="rformPrefiltro"
        @submit="setFilter($event); $refs.popupPrefiltros.close();"
        :filtersName="filtersName"
        :defaultData="mandatoryFilter"
      >
        <template v-slot="{rform}">
          <f7-list no-hairlines-md class="popupHeight">
            <div class="display-flex"
              v-for="(filtro, idx) in tableUse.prefiltros"
              :key="'prefiltro' + idx"
              :style="filtro.opciones && filtro.opciones.style ? filtro.opciones.style : null"
            >
              <simple-filter-item
                v-if="filtro.activo"
                :filtro="filtro"
                :form="rform"
                :viewTooltip="false"
                @keyup.enter.native="rform.submit()"
              >
              </simple-filter-item>
            </div>
            <div class="display-flex padding-top margin">
              <f7-button button fill type="submit" class="display-flex" icon-f7="search">{{$t('common.buscar')}}</f7-button>
            </div>
          </f7-list>
        </template>
      </r-form>
    </f7-popup>

    <f7-popup ref="popupSharedConsulta" class="popup-shared-consulta" @popup:closed="$refs.rformSharedConsulta.clear()">
      <f7-navbar :title="$t('common.sharedConsulta')">
        <f7-nav-right>
        </f7-nav-right>
      </f7-navbar>
      <r-form ref="rformSharedConsulta">
        <template v-slot="{rform}">
          <f7-list no-hairlines-md>
            <r-autocomplete-m2m
              :dbAdapter="Empleado"
              floating-label
              outline
              :label="$t('common.empleados')"
              :form="rform"
              name="empleados"
              idProp="username"
              labelProp="nombre"
              type="textarea"
              :lineBreak="true"
            ></r-autocomplete-m2m>
            <f7-button
              fill
              icon-f7="floppy_disk"
              :text="$t('common.compartir')"
              class="display-flex margin"
              @click="compartirConsulta(rform.formData.empleados)"
            ></f7-button>
          </f7-list>
        </template>
      </r-form>
    </f7-popup>

    <!-- Cambio masivo progresivo: cuadro central minimizable + barra inferior persistente. La barra
         de abajo sigue escuchando aunque se cierre el cuadro, y al reabrir recordamos que hay un
         cambio masivo en curso. -->
    <div v-if="cmActivo && cmDialogAbierto" class="cm-progreso-overlay" @click.self="cmDialogAbierto = false">
      <div class="cm-progreso-card">
        <div class="cm-progreso-titulo">{{ cmTextoEstado }} — {{ cmProcesados }} / {{ cmTotal }} procesados</div>
        <div class="cm-progreso-track">
          <div class="cm-progreso-bar" :style="{ width: cmPorcentaje + '%', background: cmColor }"></div>
          <div class="cm-progreso-tiempo" v-if="cmTiempoBarra">{{ cmTiempoBarra }}</div>
        </div>
        <div class="cm-progreso-fila">
          <span class="cm-progreso-pct">{{ cmPorcentaje }}%</span>
          <div class="cm-progreso-acciones">
            <button type="button" class="cm-btn" @click.stop="cmDialogAbierto = false">Minimizar</button>
            <button type="button" class="cm-btn cm-btn--cancelar" v-if="!cmTerminal" :disabled="cmCancelando" @click.stop="cancelarCambioMasivo">{{ cmCancelando ? 'Cancelando…' : 'Cancelar' }}</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="cmActivo && !cmDialogAbierto" class="cm-progreso-barra-inferior" @click="cmDialogAbierto = true">
      <div class="cm-progreso-barra-inferior-info">
        <span class="cm-progreso-barra-inferior-texto">{{ cmTextoEstado }} — {{ cmPorcentaje }}% ({{ cmProcesados }}/{{ cmTotal }})<span v-if="cmEta"> · {{ cmEta }}</span></span>
        <span class="cm-progreso-barra-inferior-abrir">Ver</span>
      </div>
      <div class="cm-progreso-track cm-progreso-track--fina">
        <div class="cm-progreso-bar" :style="{ width: cmPorcentaje + '%', background: cmColor }"></div>
      </div>
    </div>

  </div>
</template>
<script>

import rBadge from './rBadge';
import rPanel from "./rPanel.vue";
import rForm from "./rForm.vue";
import rInput from "./rInput.vue";
import rListFilterItem from "./rListFilterItem.vue";
import SimpleFilterItem from "./simpleFilterItem.vue";
import rAutocompleteM2m from "./rAutocompleteM2m.vue";
import rAutocomplete from "./rAutocomplete.vue";
import rMapView from "./rMapView.vue";
import rAccionesAgrupadas from "./rAccionesAgrupadas.vue";
import Ventana from "../js/Ventana.js";
import DateUtils from "../js/DateUtils";
import Utils from "../js/Utils";
import { Container, Draggable } from "vue-smooth-dnd";
import TablaUsuario from "../js/db/TablaUsuario"
import Tabla from "../js/db/Tabla"
import Empleado from "../js/db/Empleado"
import ConfigCombo from "../js/db/ConfigCombo"
import CambioMasivoEvents from "../js/db/CambioMasivoEvents"
import Flash from "../js/FlashUtils"
import preloaderDeLaSesion from "../js/utils/preloaderDeLaSesion.js"
import cerrojoDeLaSesion from "../js/utils/cerrojoDeLaSesion.js"

// Registro explícito de dbAdapters cargables por nombre desde un "ejecutor" de informe
// (columnas.ejecutores[].accion.dbAdapter). Se usan imports estáticos envueltos en función
// para carga perezosa: el import() dinámico con ruta variable no resuelve bien en este
// proyecto (webpackEmptyContext), así que evitamos esa vía y registramos aquí uno a uno.
const DB_ADAPTERS_EJECUTOR = {
  LineaPedidoNew: () => import("../js/db/LineaPedidoNew.js"),
};

const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;
  console.log(arr, dragResult);
  //const result = [...arr];
  if (!arr) arr = [];
  var result = arr;

  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  //return result;
};

export default {
  components: {
    rBadge,
    rForm,
    rPanel,
    rInput,
    rAutocompleteM2m,
    rAutocomplete,
    Container,
    Draggable,
    rListFilterItem,
    SimpleFilterItem,
    rMapView,
    rAccionesAgrupadas
  },
  data() {
    var data = this.items;
    var self = this;
    var vlParams = {
      ...{
        //el: ".virtual-list",
        items: data,
        renderExternal: this.renderExternal,
        searchAll: this.searchAll,
        setListHeight: false,
        updatableScroll: false,
        scrollableParentEl: ".virtual-list-parent",
        createUl: false,
        cache: false,
        rowsBefore: 60,
        rowsAfter: 60,
        height: this.$theme.ios ? 44 : this.$theme.md ? 48 : 38
      },
      ...this.virtualListParams
    };

    return {
      self: self,
      selected: {},
      // Modo del cambio masivo: arranca con lo declarado en el listado (showProgress). El popup
      // deja conmutarlo en caliente entre "Progresivo" (SSE por lotes con ETA) y "Todo a la vez".
      modoProgresivo: this.showProgress,
      // Estado del cambio masivo progresivo en curso (para el cuadro y la barra inferior).
      cmProgreso: null,        // último evento SSE recibido
      cmActivo: false,         // hay un cambio masivo en curso
      cmDialogAbierto: false,  // cuadro central abierto (vs minimizado a barra inferior)
      cmCancelando: false,     // se ha pedido cancelar y aún no ha llegado el evento de cancelado
      cmOnEvento: null,        // callback suscrito, para poder desuscribir
      searchColumns: null,
      count: 0,
      nomore: false,
      page: 1,
      order: this.sort,
      orderDir: this.sortDir,
      fromSort: false,
      conditions: { ...this.getFilterFromLocalStorage(), ...this.filter },
      //data: data,
      _jqxhr: null,
      loadingInfinite: false,
      loadingAggregations: false,
      loadingPtr: false,
      vlData: {
        items: []
      },
      vlParams: vlParams,
      rPanelOpenedByBreakpoint: false,
      filtersName: undefined,
      DateUtils,
      Utils,
      TablaUsuario,
      Tabla,
      Empleado,
      columns: [],
      agregaciones: [],
      agregacionesValor: [],
      // La identidad de la consulta que la tabla está enseñando: sube cada vez que la tabla se
      // queda sin filas (`clearData`), que es por donde pasan todas las búsquedas nuevas. El scroll
      // infinito NO pasa por ahí, así que sus páginas comparten identidad con la búsqueda que las
      // pidió: se conservan, y una página de otra consulta se rechaza.
      consultaVigente: 0,
      // La identidad de la última consulta para la que se ha LANZADO una carga de filas. Comparada
      // con `consultaVigente` dice si la búsqueda que ha sustituido a una respuesta obsoleta tiene
      // ya su propia petición en el aire, y por tanto quién suelta los estados de carga (ver
      // `cargaVigenteEnVuelo`). Empieza a `null` y no a 0 para que al nacer no parezca que hay una
      // carga en marcha.
      consultaCargando: null,
      searched: false,
      tableUse: false,
      sendToSAP: false,
      popupCambioMasivoOpened: false,
      popupPrefiltrosOpened: false,
      ejecutorActivo: null,
      dbAdapterEjecutor: null,
      itemClicked: null,
      rowsPerPageUsed: self.rowsPerPage,
      widthCheckColumn: 40,
      massiveActionsData: self.massiveActions,
      searcherConfigColumns: "",
      controlsWidthAplicable: this.controlsWidth,
      tiempoCarga: 0,
      tiempoCargaSumatorios: 0,
      vistaActual: 'LISTADO', // 'LISTADO' o 'MAPA'
      loadingMapData: false,
      allMapItemsLoaded: false,
      mapData: [], // Datos cargados solo para el mapa (independiente del listado)
      mapFilteredData: [],
      mapFilterConditions: {},
      selectedMapDirection: 0, // Índice de la dirección seleccionada en el mapa
      // Cuándo se cerró por última vez el menú de consultas (ver abrirMenuConsultas).
      consultasMenuCerradoEn: 0
    }; // FALTA: virtualListParams como prop y altura automática para parent
  },
  props: {
    classContent: {},
    classList: {},
    dbAdapter: {
      type: Object
    },
    mandatoryFilter: {
      type: Object,
      default() {
        return {};
      }
    },
    rowsPerPage: {
      type: Number,
      default: 100
    },
    useView: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    virtualListParams: {
      type: Object,
      default() {
        return {};
      }
    },
    primary: {
      type: Array,
      default: function() {
        return ["id"];
      }
    },
    sort: {
      type: String,
      default: "creationDate"
    },
    sortDir: {
      type: String,
      default: "DESC"
    },
    tableMode: {
      type: Boolean,
      default: false
    },
    massiveActions: {
      type: Boolean,
      default: false
    },
    massiveActionsSelectAll: {
      type: Boolean,
      default: false
    },
    infiniteScroll: {
      type: Boolean,
      default: true
    },
    // Descartar las respuestas de una consulta que ya se ha sustituido por otra. Lo enciende quien
    // lo necesita —hoy la consulta de Clientes, por su recuento (#205)— y **por defecto está
    // apagado**: esta tabla es la misma en todas las consultas del programa (Facturas,
    // Expedientes, Pedidos…) y aquí no se cambia cómo se comportan las demás.
    //
    // Encendido, una respuesta que llega cuando ya se ha lanzado otra búsqueda no toca nada: ni
    // las filas, ni la página, ni `nomore`, ni los estados de carga, ni emite `load`. Lo que NO
    // hace es cancelar la petición: la política de cancelación es global y se deja como está —la
    // respuesta llega y se tira—, que es lo que se acordó al decidir este planteamiento.
    descartarRespuestasObsoletas: {
      type: Boolean,
      default: false
    },
    shownFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tableCode: {
      type: String,
      default: ""
    },
    filtersNoCounters: {
      type: Array,
      default: function() {
        return [];
      }
    },
    mostrarBadgeFilters: {
      type: Boolean,
      default: true
    },
    searchOnInit: {
      type: Boolean,
      default: false
    },
    filterPosition: {
      //Valores HEADER o PANEL
      type: String,
      default: "HEADER"
    },
    funcShowCheck: {
      type: Function,
      default: function(item) {
        return true;
      }
    },
    beforeSearch: {
      type: Function,
      default: function(filter) {
        return filter;
      }
    },
    customLineStyle: {
      type: Function,
      default: (item) => ''
    },
    controlsWidth: {
      type: Number,
      default: 100
    },
    // Agrupar las acciones de cada línea (ojo, lápiz, papelera...) en un solo icono que las despliega
    // al pasar el ratón o mantenerlo pulsado. Apagándolo se pintan todas en la celda, como antes.
    agruparAcciones: {
      type: Boolean,
      default: true
    },
    tipoConsultasEstaticas: {
      type: String,
      default: ""
    },
    paginationFilterSort: {
      type: Boolean,
      default: false
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    filterColumns: {
      type: Function,
      default: function(columns) {
        return columns;
      }
    },
    ignoreTableFilters: {
      type: Boolean,
      default: false
    },
    popupActionsRenderer: {
      type: Function,
      default: null
    }
  },
  watch: {
    vistaActual(newVal) {
      const self = this;
      if (newVal === 'MAPA' && !self.searched) {
        console.log('[MAP] No se carga mapa todavía: pendiente ejecutar búsqueda en listado');
        self.$set(self, 'mapData', []);
        return;
      }

      if (newVal === 'MAPA' && !self.allMapItemsLoaded && self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa && self.tableUse.opciones.mapa.habilitado) {
        self.loadAllForMap();
      }
    }
  },
  mounted() {
    var self = this;
    var app = self.$f7;

    // Una tabla recién montada todavía no tiene filas, y lo dice. Parece redundante, pero es la
    // pata que faltaba: cuando un `v-if` destruye la tabla y la vuelve a montar —el popup de
    // «Buscar Duplicados» de Clientes—, la pantalla sigue viva y conserva lo que hubiera calculado
    // sobre las filas de la tabla ANTERIOR. Con este aviso, cualquier tabla nueva nace diciendo
    // que no tiene nada que enseñar, sin que la pantalla tenga que vigilar por qué se recreó.
    self.$emit("clear-data");

    self.$f7ready(f7 => {
      f7.on('pageMounted', self.onPageMounted);
    });

    var $content = self.$$(self.$el).find(".ptr-content");
    var $infinite_content = self.$$(self.$el).find(".infinite-scroll-content");
    app.ptr.create($content[0]);
    app.infiniteScroll.create($infinite_content[0]);

    if (!self.tipoConsultasEstaticas) {
      self.changeTable(self.tableCode, self.massiveActions);
    }

    // Si esta tabla usa el cambio masivo progresivo y hay uno en curso en el servidor (p.ej. se
    // navegó y se volvió), lo reenganchamos para seguir viendo el progreso.
    if (self.showProgress) {
      self.cmComprobarEnCurso();
    }

    if (self.dbAdapter || self.tipoConsultasEstaticas) {
      $content.on("ptr:refresh", function(e) {
        if (self.loadingPtr) return;
        self.initRemoteData();
      });
      if (self.infiniteScroll && !self.tipoConsultasEstaticas) {
        $infinite_content.on("infinite", function() {
          if (self.loadingInfinite || self.nomore || !self.searched) return;
          self.page = self.page + 1;
          self.getRemoteData(false);
        });
      }
      // if (self.searchOnInit && !self.tipoConsultasEstaticas) {
      //   self.refresh();
      // }
    }
  },
  beforeDestroy() {
    var self = this;
    var app = self.$f7;
    // Por `clearData`, no vaciando las filas aquí a mano: era la segunda copia del mismo gesto, y
    // por eso morir no avisaba a la pantalla mientras vaciarse sí. Ahora la tabla se queda sin
    // filas por un único sitio, y ese sitio es el que lo cuenta.
    self.clearData();
    // No cerramos el canal SSE del cambio masivo aquí: es un singleton de módulo y queremos que
    // siga vivo aunque se navegue. Solo soltamos nuestro callback.
    if (self.cmOnEvento) {
      CambioMasivoEvents.unsubscribe(self.cmOnEvento);
    }
  },
  computed: {
    cmTerminal() {
      const e = this.cmProgreso;
      return !!e && (e.estado === 'fin' || e.estado === 'cancelado' || e.estado === 'error');
    },
    cmPorcentaje() {
      const e = this.cmProgreso;
      return e ? Math.round(e.porcentaje || 0) : 0;
    },
    cmProcesados() {
      return (this.cmProgreso && this.cmProgreso.procesados) || 0;
    },
    cmTotal() {
      return (this.cmProgreso && this.cmProgreso.total) || 0;
    },
    cmColor() {
      const e = this.cmProgreso;
      if (!e) return '#4CAF50';
      if (e.estado === 'error') return '#f44336';
      if (this.cmTerminal) {
        const fallidos = (e.resumen && e.resumen.fallidos) || 0;
        return fallidos > 0 ? '#FF9800' : '#4CAF50';
      }
      return '#4CAF50';
    },
    cmTextoEstado() {
      const e = this.cmProgreso;
      if (!e) return 'Actualizando registros…';
      if (e.estado === 'fin') return 'Actualización completada';
      if (e.estado === 'cancelado') return 'Actualización cancelada';
      if (e.estado === 'error') return 'Error en la actualización';
      return 'Actualizando registros…';
    },
    cmDetalle() {
      const e = this.cmProgreso;
      if (!e) return '';
      let linea = (e.procesados || 0) + ' / ' + (e.total || 0) + ' procesados';
      if (this.cmTerminal && e.resumen) {
        if (e.resumen.ok != null) linea += ' · ' + e.resumen.ok + ' correctos';
        if (e.resumen.fallidos > 0) linea += ' · ' + e.resumen.fallidos + ' con errores';
      }
      return linea;
    },
    cmEta() {
      const e = this.cmProgreso;
      if (!e) return '';
      if (!this.cmTerminal && e.etaSegundos != null) {
        return 'Tiempo restante: ' + this.formatearDuracionSegundos(e.etaSegundos);
      }
      if (this.cmTerminal && e.transcurridoSegundos != null) {
        return 'Tiempo total: ' + this.formatearDuracionSegundos(e.transcurridoSegundos);
      }
      return '';
    },
    // Tiempo consumido y estimado, para pintarlo sobre la barra: "8 s · restan 12 s" / "20 s total".
    cmTiempoBarra() {
      const e = this.cmProgreso;
      if (!e) return '';
      const transcurrido = e.transcurridoSegundos != null ? this.formatearDuracionSegundos(e.transcurridoSegundos) : null;
      if (this.cmTerminal) {
        return transcurrido ? (transcurrido + ' total') : '';
      }
      const eta = e.etaSegundos != null ? this.formatearDuracionSegundos(e.etaSegundos) : null;
      let s = transcurrido || '';
      if (eta) {
        s += (s ? ' · ' : '') + 'restan ' + eta;
      }
      return s;
    }
  },
  methods: {
    onPageMounted(page) {
      const self = this;
      let refreshList = Flash.get("refreshList");
      if (refreshList) {
        self.reload();
      }
    },

    getSearcherConfigColumns(columns) {
      const self = this;
      if (!self.searcherConfigColumns) {
        return columns;
      }
      let searcherStr = self.searcherConfigColumns.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      return columns.filter(columna => {
        let nombre = self.$t(columna.nombre).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return nombre.includes(searcherStr);
      });
    },
    changeTable(tableCode, massiveActions = false) {
      const self = this;
      const app = self.$f7;
      if (!tableCode) {
        self.changeConsulta(null, true);
        self.columns = [];
        self.tableUse = false;
        return;
      }
      // #663 · Las esperas de esta tabla son de la sesión (`preloaderDeLaSesion`): si cambia en
      // vuelo, la frontera calla el `finally` o el `then` que las apagaba y el indicador global se
      // quedaba encima del acceso. Los cerrojos de carga, por lo mismo, con `cerrojoDeLaSesion`.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      self.Tabla.getTabla(tableCode).then(r => {
        self.tableUse = r;
        // si la tabla tiene informada la opción controlsWidth, se sobreescribe el valor por defecto
        if (self.tableUse.opciones && typeof self.tableUse.opciones.controlsWidth === 'number') {
          self.controlsWidthAplicable = self.tableUse.opciones.controlsWidth;
        }
        // Precargamos los configcombos referenciados por los filtros ANTES de asignar
        // self.columns, para que cuando Vue renderice los <r-autocomplete-m2m> de los
        // filtros ya reciban los items poblados via :dbItems desde el primer mount.
        return self.precargarConfigCombosDeFiltros(self.tableUse.columnas);
      }).then(() => {
        self.columns = self.tableUse.columnas.map(c => {
          c.activaUsuario = true;
          return c;
        });
        self.agregaciones = self.tableUse.funcionesAgregadas.map(c => {
          c.activaUsuario = true;
          return c;
        });
        self.initialColumns = JSON.parse(JSON.stringify(self.columns));
        self.massiveActionsData = massiveActions;
        if (self.$refs.consultasCombo) {
          self.$refs.consultasCombo.reload(self.tableUse.consultasFavoritas);
        }

        self.rowsPerPageUsed = self.tableUse && self.tableUse.opciones && self.tableUse.opciones.rowsPerPage ? self.tableUse.opciones.rowsPerPage : self.rowsPerPage;

        self.changeConsulta(self.getConsultaDefecto());

        if ((self.dbAdapter || self.tipoConsultasEstaticas) && self.searchOnInit) {
          if (self.tableUse.prefiltros && self.tableUse.prefiltros.length) {
            self.popupPrefiltrosOpened = true;
          } else {
            self.$nextTick(() => {
              self.setFilter(self.getFilterData());
            });
          }
        }
		
      }).catch(error => {
        var message = typeof error == "string" ? error : error.message;
        app.dialog.alert(message);
      }).finally(() => espera.cerrar());

    },
    precargarConfigCombosDeFiltros(columnas) {
      const self = this;
      if (!columnas || !columnas.length) return Promise.resolve();
      const codigosUnicos = {};
      columnas.forEach(function (c) {
        if (c.filtro && c.filtro.configCombo) codigosUnicos[c.filtro.configCombo] = true;
        if (c.cambioMasivo && c.cambioMasivo.configCombo) codigosUnicos[c.cambioMasivo.configCombo] = true;
      });
      const codigos = Object.keys(codigosUnicos);
      if (!codigos.length) return Promise.resolve();
      const peticiones = codigos.map(function (codigo) {
        return ConfigCombo.getList({ filter: { codigo: codigo } })
          .then(function (res) {
            const combo = res && res.list && res.list[0];
            const valores = (combo && combo.valores) || [];
            return { codigo: codigo, valores: valores };
          })
          .catch(function () { return { codigo: codigo, valores: [] }; });
      });
      return Promise.all(peticiones).then(function (resultados) {
        const porCodigo = {};
        resultados.forEach(function (r) { porCodigo[r.codigo] = r.valores; });
        const construyeItems = function (valores) {
          return valores.map(function (v) {
            const labelHumano = v.label || v.nombre || v.nombre_valor || v.valor;
            return Object.assign({}, v, v.metadatos || {}, {
              label: labelHumano,
              nombre: labelHumano,
              valor: v.valor
            });
          });
        };
        columnas.forEach(function (c) {
          if (c.filtro && c.filtro.configCombo) {
            const items = construyeItems(porCodigo[c.filtro.configCombo] || []);
            c.filtro.items = items;
            const tieneColores = items.some(function (it) { return it.badgeColor; });
            if (tieneColores) {
              c.colores = items.map(function (it) {
                return { nombre: it.valor, valor: it.badgeColor || 'gray' };
              }).concat([{ nombre: 'DEFAULT', valor: 'gray' }]);
            }
          }
          if (c.cambioMasivo && c.cambioMasivo.configCombo) {
            c.cambioMasivo.items = construyeItems(porCodigo[c.cambioMasivo.configCombo] || []);
          }
        });
      });
    },
    cellText(item, column){
      const self = this;
      var text;
      var valorItem = self.getValorItem(item, column);
      switch(column.tipo){
        case "FECHA":
        case "FECHAHORA":
          text = self.$options.filters.dateFormat(self.$options.filters.dateParse(valorItem || column.valorVacio), column.formato);
          break;
        case "NUMERO":
          // Si el valor del item no es numérico, se devuelve el valor vacío
          if (valorItem == null || (valorItem + "") == "" || isNaN(valorItem)) {
            text = isNaN(column.valorVacio) ? self.$options.filters.numberFormat(column.valorVacio, column.formato, ',', '.'):column.valorVacio;
          } else {
            text = self.$options.filters.numberFormat(valorItem, column.formato, ',', '.');
          }
          // text = self.$options.filters.numberFormat(valorItem == undefined ? column.valorVacio : valorItem, column.formato, ',', '.');
          break;
        case "BOOLEAN":
          text = (valorItem != undefined && valorItem != null) ? (valorItem ? 'Si' : 'No') : "";
          if (!text && column.filtro && column.filtro.operation == "EXISTS") {
            text = "No";
          }
          return text;
      }
      if(column.sufijo && text != undefined && text != null && text != ""){
        text = text + " " + column.sufijo;
      }
      return text;
    },
    // ---- Acciones agrupadas por línea -------------------------------------------------------
    accionesAgrupadas() {
      // Solo en tablet y móvil (mismo corte que rAccionesAgrupadas): en pantallas grandes los iconos
      // caben sin estorbar y se pintan sueltos. `Ventana.ancho` es reactivo.
      return this.agruparAcciones && Ventana.ancho <= 1024 && !!this.$scopedSlots.optionsColumn;
    },
    // Menú de la consulta favorita (guardar / eliminar / compartir / borrar contenido).
    abrirMenuConsultas(event) {
      const popover = this.$refs.popoverConsultas;
      if (!popover || !popover.f7Popover) {
        return;
      }
      // Framework7 escucha el click en captura: si estaba abierto, al tocar los tres puntos lo cierra
      // por "toque fuera" ANTES de llegar aquí, y reabrirlo a mitad de animación lo dejaba colgado
      // (nunca disparaba "opened" y ya no se cerraba tocando fuera). Ese toque es un cierre: se ignora.
      if (Date.now() - this.consultasMenuCerradoEn < 300) {
        return;
      }
      if (!popover.f7Popover.opened) {
        popover.open(event.currentTarget || event.target);
      }
    },
    // En móvil (≤600px, el corte del CSS de móvil) ni siquiera hay icono: las acciones se abren
    // tocando la fila y la columna de controles desaparece.
    accionesPorFila() {
      return this.accionesAgrupadas() && Ventana.ancho <= 600;
    },
    // Ancho de la columna de controles: con las acciones agrupadas solo hay que alojar un icono; con
    // las acciones por fila, nada.
    anchoControles() {
      if (this.accionesPorFila()) {
        return 0;
      }
      return this.accionesAgrupadas() ? 48 : this.controlsWidthAplicable;
    },
    clickFila(item, event) {
      this.itemClicked = this.getPrimary(item);
      if (!this.accionesPorFila()) {
        return;
      }
      const refs = this.$refs["acciones-" + this.getPrimary(item)];
      const comp = Array.isArray(refs) ? refs[0] : refs;
      if (comp) {
        // El componente ignora los toques en enlaces/checkbox y ancla el panel a la fila, pegado al
        // borde derecho visible del contenedor que hace scroll horizontal.
        comp.toqueEnFila(event);
      }
    },
    styleWidthCelda(column){
      var self = this;
      return `width: ${self.widthCelda(column)}px;${column.opciones && column.opciones.style ? column.opciones.style : ''}`;
    },
    styleWidthLinea(){
      var self = this;
      return `width: ${self.widthLinea()}px;`;
    },
    widthCelda(column){
      var self = this;
      return (column.opciones && column.opciones.width) ? column.opciones.width : 200;
    },
    widthLinea(){
      var self = this,
        columns = self.getColumnsFiltered();
      // El ancho de la columna de controles es el APLICABLE (la tabla puede sobreescribir la prop
      // con opciones.controlsWidth); si no, la última celda no cabe y salta a una segunda línea.
      return Array.from(columns).reduce((acc, column) => acc + self.widthCelda(column), self.widthCheckColumn + self.anchoControles() + 8);
    },
    listScroll(eve){
      const self = this,
        scrollList = eve.target,
        scrollTop = scrollList.scrollTop,
        scrollHeight = scrollList.scrollHeight,
        offsetHeight = scrollList.offsetHeight;
      if (self.tipoConsultasEstaticas) {
        return;
      }
      if(self.updateScroll){
        clearTimeout(self.updateScroll);
      }
      self.updateScroll = setTimeout(() => {
        if(scrollTop + offsetHeight > scrollHeight - 100 && scrollList.scrollHeight > scrollList.offsetHeight){
          self.page++;
          self.getRemoteData();
        }
      },200);
    },
    loadNextPage(){

    },
    getClassesAgregaciones() {
      const self = this;
      if (self.tableUse.opciones && self.tableUse.opciones.divAgregacionesClases) {
        return self.tableUse.opciones.divAgregacionesClases;
      } else {
        return ["col-100", "medium-50", "xlarge-33"];
      }
    },
    removeFilter(column) {
      const self = this;
      var filterItem = self.$refs['header-item-' + column.pathName];
      if (filterItem && Array.isArray(filterItem)) {
        filterItem.forEach(f => {
          f.cleanData();
        });
      } else if (filterItem) {
        filterItem.cleanData();
      }
    },
    getPathName: function(column) {
      const self = this;
      var pathName = column.pathName;
      if (self.tipo == "FILTRO") {
        pathName = column.filtro.pathName || column.pathName;
        pathName = pathName.replaceAll(".", "##");
      } else if (self.tipo == "MASIVO") {
        pathName = column.cambioMasivo.pathName || column.pathName;
      }
      return pathName;
    },
    onConfigColumnsAllChange: function ($event) {
      var self = this;
      if (!$event || !$event.target) {
        return;
      }
      self.columns.forEach(c => {
        c.activaUsuario = $event.target.checked;
      })
      self.clearAll();
    },
    onConfigAgregacionesAllChange: function ($event) {
      var self = this;
      if (!$event || !$event.target) {
        return;
      }
      self.agregaciones.forEach(c => {
        c.activaUsuario = $event.target.checked;
      })
      self.clearAll();
    },
    abrirPopupListado (item, column) {
      const self = this;
      if (column.opciones && column.opciones.openEmail) {
        var elementColumn = self.getValorOriginalItem(item, column);
        var strResult = elementColumn.map(insp => {
          if (column.opciones.stringifyField == true) {
            return insp;
          } else {
            return insp[column.opciones.stringifyField]
          }
        }).join(";");
        window.location.href = "mailto:" + strResult;
        return;
      }
      var pathName = self.getCleanPathName(column.pathName);
      var auxFieldsItems = column.pathName && column.pathName.indexOf && column.pathName.indexOf("|") > -1 ? column.pathName.split("|")[1] : undefined;
      var fieldsItem = auxFieldsItems ? auxFieldsItems.split(",") : undefined;
      var namespaces = pathName ? pathName.split(".") : [];
      var context = item;
      var iFinal = 0;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        if (typeof context == "undefined" || context == null) context = {};
        if (Array.isArray(context)) {
          iFinal = i;
          break;
        } else {
          iFinal++;
          context = context[namespaces[i]];
        }
        
      }

      namespaces.splice(0, iFinal);

      var itemspopup = [];

      for (var i = 0; i < context.length; i++) {
        var itemList = context[i];
        var itemPopup = [];
        
        // Si hay stringifyField configurado y es una expresión evaluable, usarla para formatear el elemento
        if (column.opciones && column.opciones.stringifyField && typeof column.opciones.stringifyField === 'string' && column.opciones.stringifyField.includes('element.')) {
          try {
            // Crear una función que tenga acceso al itemList como element en su contexto
            const evalFunction = new Function('element', 'return ' + column.opciones.stringifyField);
            var formattedValue = evalFunction(itemList);
            itemPopup.push(formattedValue || "");
          } catch (error) {
            console.error("Error evaluando stringifyField:", error);
            // Si hay error en la evaluación, usar el comportamiento original
            if (fieldsItem && fieldsItem.length) {
              for (var j = 0; j < fieldsItem.length; j++) {
                var field = fieldsItem[j];
                var namespacesItems = [...namespaces, ...(field && typeof field === 'string' ? field.split(".") : [])];
                var valor = self.getValorObjectByNamespaces(itemList, namespacesItems);
                itemPopup.push(valor ? valor : "");
              }
            } else {
              itemPopup.push(itemList)
            }
          }
        } else {
          // Comportamiento original si no hay stringifyField configurado
          if (fieldsItem && fieldsItem.length) {
            for (var j = 0; j < fieldsItem.length; j++) {
              var field = fieldsItem[j];
              var namespacesItems = [...namespaces, ...(field && typeof field === 'string' ? field.split(".") : [])];
              var valor = self.getValorObjectByNamespaces(itemList, namespacesItems);
              itemPopup.push(valor ? valor : "");
            }
          } else {
            itemPopup.push(itemList)
          }
        }
        itemspopup.push(itemPopup);
      }

      var itemsStr = "<ul>";
      itemspopup.forEach(ip => {
        itemsStr = itemsStr + '<li>';
        ip.forEach((ip2, idx) => {
          if (idx > 0) {
            itemsStr = itemsStr + ' - ';
          }
          itemsStr = itemsStr + ip2;
        })
        itemsStr = itemsStr + '</li>';
      })
      itemsStr = itemsStr + '</ul>';

      if (self.popupListado) {
        self.popupListado.destroy();
      }
      // Create popup
      self.popupListado = self.$f7.popup.create({
        content: `
          <div class="popup">
            <div class="page">
              <div class="navbar">
                <div class="navbar-bg"></div>
                <div class="navbar-inner">
                  <div class="title">` + self.$t(column.nombre) + `</div>
                  <div class="right"><a href="#" class="link popup-close">x</a></div>
                </div>
              </div>
              <div class="page-content">
                ` + itemsStr + `
              </div>
            </div>
          </div>
        `.trim(),
      });
      // Open it
      self.popupListado.open();
    },
    cambioMasivo(formData) {
      var self = this;
      var app = self.$f7;
      if (formData.type && formData.type == 'submit') {
        return;
      }

      // Todos los campos de primary son obligatorios: el backend trocea la key por posición
      // (id.split("-")[0], [1]...), así que una key a la que le falte un tramo no la sabe
      // interpretar. Si un campo del primary puede venir vacío es que ese primary no
      // corresponde a lo que está listando la tabla: hay que corregirlo en la pantalla, no
      // relajar esto (ver lineaspedidos.vue, que calcula el primary según el reparto elegido).
      const camposPrimary = self.primaryEfectivo() || [];
      const camposVacios = data => camposPrimary.filter(p => {
        const val = self.getValorObjectByNamespaces(data, p && typeof p === 'string' ? p.split(".") : []);
        return val === undefined || val === null || val === "";
      });
      const faltantes = new Set();
      const idsInvalidos = Object.keys(self.selected).filter(id => {
        const data = self.selected[id];
        if (!data) {
          camposPrimary.forEach(p => faltantes.add(p));
          return true;
        }
        const vacios = camposVacios(data);
        vacios.forEach(p => faltantes.add(p));
        return !!vacios.length;
      });
      if (idsInvalidos.length) {
        app.dialog.alert("No se puede aplicar el cambio masivo: " + idsInvalidos.length + " de las filas seleccionadas no tienen relleno alguno de los campos identificadores (" + Array.from(faltantes).join(", ") + "). Revisa esas filas antes de continuar.");
        return;
      }

      self.normalizarFechasMasivo(formData);

      const dbAdapterActivo = self.dbAdapterEjecutor || self.dbAdapter;
      if (dbAdapterActivo) {
        // Dentro del `if`: sin adaptador no hay nada que esperar, y un testigo sin nadie que lo
        // suelte dejaría el indicador puesto el resto de la sesión.
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        let vaciarCampos = formData.vaciarCampos;
        delete formData.vaciarCampos;
        dbAdapterActivo.putAll({itemIds: Object.keys(self.selected), data: formData, vaciarCampos: vaciarCampos})
        .then(r => {
          app.dialog.alert("Cambios realizados en " + r.list.length + " objetos.");
          if (self.$refs.popupCambioMasivo) {
            self.$refs.popupCambioMasivo.close();
          }
          self.desactivarEjecutor();
          setTimeout(() => self.reload(), 1000);
          // self.reload();
        })
        .catch(error => {
          var message = typeof error == "string" ? error : error.message;
          app.dialog.alert(message);
        }).finally(() => espera.cerrar());
      }

    },
    normalizarFechasMasivo(formData) {
      const self = this;
      self.getActiveColumnsMasivo().forEach(column => {
        if (column.tipo !== 'FECHA' && column.tipo !== 'FECHAHORA') return;
        const pathName = (column.cambioMasivo && column.cambioMasivo.pathName) || column.pathName;
        if (!pathName) return;
        const namespaces = pathName.split(".");
        let context = formData;
        for (let i = 0; i < namespaces.length - 1; i++) {
          if (context[namespaces[i]] == null) return;
          context = context[namespaces[i]];
        }
        const key = namespaces[namespaces.length - 1];
        let val = context[key];
        if (val == null || val === '') return;
        if (typeof val === 'string') {
          // DD/MM/YYYY primero: new Date('07/04/2026') lo interpretaría como MM/DD (formato USA)
          const dmy = val.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
          let parsed = dmy ? new Date(+dmy[3], dmy[2] - 1, +dmy[1]) : new Date(val);
          val = parsed;
        }
        if (val instanceof Date && !isNaN(val.getTime())) {
          context[key] = val.toISOString();
        }
      });
    },
    cambioMasivoProgress(formData) {
      var self = this;
      var app = self.$f7;
      if (formData.type && formData.type == 'submit') {
        return;
      }

      const adapter = self.dbAdapterEjecutor || self.dbAdapter;
      if (!adapter) {
        return;
      }

      // Si ya hay un cambio masivo en curso (nuestro o detectado en el servidor), no lanzamos otro:
      // mostramos el cuadro con su progreso.
      if (self.cmActivo) {
        self.cmDialogAbierto = true;
        return;
      }

      // Mismo guard que el clásico: no dejar pasar filas sin ningún identificador.
      const camposPrimary = self.primaryEfectivo() || [];
      const faltantes = new Set();
      const idsInvalidos = Object.keys(self.selected).filter(id => {
        const data = self.selected[id];
        if (!data) { camposPrimary.forEach(p => faltantes.add(p)); return true; }
        const vacios = camposPrimary.filter(p => {
          const val = self.getValorObjectByNamespaces(data, p && typeof p === 'string' ? p.split(".") : []);
          return val === undefined || val === null || val === "";
        });
        vacios.forEach(p => faltantes.add(p));
        return !!vacios.length;
      });
      if (idsInvalidos.length) {
        app.dialog.alert("No se puede aplicar el cambio masivo: " + idsInvalidos.length + " de las filas seleccionadas no tienen relleno alguno de los campos identificadores (" + Array.from(faltantes).join(", ") + "). Revisa esas filas antes de continuar.");
        return;
      }

      self.normalizarFechasMasivo(formData);

      let vaciarCampos = formData.vaciarCampos;
      delete formData.vaciarCampos;

      const selectedIds = Object.keys(self.selected);

      self.cmAdapter = adapter;
      self.cmProgreso = { estado: 'inicio', texto: 'Iniciando actualización…', procesados: 0, total: selectedIds.length, porcentaje: 0 };
      self.cmActivo = true;
      self.cmDialogAbierto = true;
      self.cmCancelando = false;

      // Nos suscribimos al canal del usuario y lanzamos el trabajo SOLO cuando el canal está
      // conectado (onReady), para no perder eventos de jobs muy rápidos. El progreso llega por
      // eventos y la petición de lanzamiento vuelve enseguida, así que no hay 524.
      self.cmSuscribirYEscuchar(adapter, () => {
        adapter.lanzarCambioMasivoSse({ itemIds: selectedIds, data: formData, vaciarCampos: vaciarCampos })
          .then(r => {
            if (r && r.lanzado === false && !r.enCurso) {
              self.cmFinalizarUI();
              app.dialog.alert(r.error || 'No se ha podido lanzar el cambio masivo.', 'Cambio masivo');
            }
          })
          .catch(error => {
            self.cmFinalizarUI();
            var message = typeof error == "string" ? error : error.message;
            app.dialog.alert(message, 'Cambio masivo');
          });
      });

      // Cerramos el popup del formulario: el progreso ya se ve en el cuadro / barra inferior.
      if (self.$refs.popupCambioMasivo) {
        self.$refs.popupCambioMasivo.close();
      }
      if (self.desactivarEjecutor) self.desactivarEjecutor();
    },

    // Suscribe al canal SSE del cambio masivo y vuelca cada evento sobre el estado reactivo
    // (cmProgreso), de modo que el cuadro central y la barra inferior se actualizan solos. onReady
    // se llama cuando el canal está conectado.
    cmSuscribirYEscuchar(adapter, onReady) {
      var self = this;
      var app = self.$f7;
      if (self.cmOnEvento) {
        CambioMasivoEvents.unsubscribe(self.cmOnEvento);
      }
      self.cmOnEvento = (ev) => {
        if (!ev || typeof ev !== 'object') return;
        self.cmProgreso = ev;
        self.cmActivo = true;
        const terminal = ev.estado === 'fin' || ev.estado === 'cancelado' || ev.estado === 'error';
        if (!terminal) return;
        const resumen = ev.resumen || {};
        setTimeout(() => {
          if (ev.estado === 'error') {
            app.dialog.alert(ev.texto || 'Error en el cambio masivo.', 'Cambio masivo');
          } else if (ev.estado === 'cancelado') {
            app.toast.create({ text: '⏹️ ' + (ev.texto || 'Cambio masivo cancelado.'), position: 'center', destroyOnClose: true, closeTimeout: 3000 }).open();
          } else if ((resumen.fallidos || 0) > 0) {
            app.dialog.alert(`Cambio masivo completado con advertencias:<br><strong>${resumen.ok || 0}</strong> correctos<br><strong>${resumen.fallidos}</strong> con errores`, 'Cambio masivo');
          } else {
            app.toast.create({ icon: '<i class="f7-icons">checkmark_circle_fill</i>', text: `${resumen.ok != null ? resumen.ok : (ev.procesados || 0)} registros actualizados correctamente`, position: 'center', destroyOnClose: true, closeTimeout: 3000 }).open();
          }
          self.cmFinalizarUI();
          setTimeout(() => self.reload(), 800);
        }, 800);
      };
      CambioMasivoEvents.subscribe(adapter, self.cmOnEvento, onReady);
    },

    // Limpia el estado del cambio masivo y suelta el canal.
    cmFinalizarUI() {
      var self = this;
      self.cmActivo = false;
      self.cmDialogAbierto = false;
      self.cmCancelando = false;
      self.cmProgreso = null;
      if (self.cmOnEvento) {
        CambioMasivoEvents.unsubscribe(self.cmOnEvento);
        self.cmOnEvento = null;
      }
    },

    // Cancela (cooperativo) el cambio masivo en curso. El cancelado real llega como evento SSE tras
    // terminar el registro en curso; mientras, marcamos cmCancelando para dar feedback inmediato.
    cancelarCambioMasivo() {
      var self = this;
      if (self.cmCancelando) return;
      const adapter = self.cmAdapter || self.dbAdapterEjecutor || self.dbAdapter;
      if (adapter && adapter.cancelarCambioMasivoSse) {
        cerrojoDeLaSesion(self, 'cmCancelando');
        adapter.cancelarCambioMasivoSse().catch(() => { self.cmCancelando = false; });
      }
    },

    // Al montar o al abrir el popup: si el servidor dice que hay un cambio masivo en curso (p.ej.
    // porque se navegó y se volvió, o se lanzó desde otra pestaña), reenganchamos el progreso.
    cmComprobarEnCurso() {
      var self = this;
      const adapter = self.dbAdapterEjecutor || self.dbAdapter;
      if (!adapter || !adapter.estadoCambioMasivoSse || self.cmActivo) return;
      adapter.estadoCambioMasivoSse().then(est => {
        if (est && est.enCurso && !self.cmActivo) {
          self.cmAdapter = adapter;
          self.cmProgreso = {
            estado: 'progreso',
            texto: 'Actualizando registros…',
            procesados: est.procesados || 0,
            total: est.total || 0,
            porcentaje: est.total ? Math.round((est.procesados || 0) * 100 / est.total) : 0
          };
          self.cmActivo = true;
          self.cmDialogAbierto = false; // aparece como barra inferior
          self.cmSuscribirYEscuchar(adapter, null);
        }
      }).catch(() => {});
    },

    // Abre el cambio masivo: si ya hay uno en curso, muestra su progreso en vez del formulario.
    abrirCambioMasivo() {
      var self = this;
      if (self.cmActivo) {
        self.cmDialogAbierto = true;
        return;
      }
      self.popupCambioMasivoOpened = true;
      self.cmComprobarEnCurso();
    },
    // Formatea segundos como "45 s" o "2 min 05 s", para el ETA del cambio masivo progresivo.
    formatearDuracionSegundos(segs) {
      if (segs == null || isNaN(segs)) return '';
      segs = Math.max(0, Math.round(segs));
      if (segs < 60) return segs + ' s';
      const m = Math.floor(segs / 60);
      const s = segs % 60;
      return m + ' min ' + (s < 10 ? '0' : '') + s + ' s';
    },
    compartirConsulta(empleados) {
      var self = this;
      var app = self.$f7;

      const consulta = self.$refs.rformConsultas.formData.consulta;

      if (!consulta) {
        app.dialog.alert("Elige una consulta a compartir");
        return;
      }

      if (consulta.nombre == "Defecto") {
        app.dialog.alert("La consulta por defecto no se puede compartir, elija otra.");
        return;
      }

      if (!empleados || !empleados.length) {
        app.dialog.alert("Elige empleados con quien compartir");
        return;
      }

      const data = {
        codigoTabla: self.tableUse.codigo,
        usernames: empleados,
        consulta: consulta
      }
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      TablaUsuario.sharedConsulta({data: data}).then(res => {
        app.toast
        .create({
          icon: '<i class="f7-icons">checkmark</i>',
          text: self.$t("common.consultaCompartida"),
          position: "center",
          destroyOnClose: true,
          closeTimeout: 2000
        })
        .open();
        if (self.$refs.popupSharedConsulta) {
          self.$refs.popupSharedConsulta.close();
        }
      }).catch(error => {
        var message = typeof error == "string" ? error : error.message;
        app.dialog.alert(message);
      }).finally(() => espera.cerrar());

    },
    deleteConsulta(consulta) {
      var self = this;
      var app = self.$f7;

      if (!consulta) {
        app.dialog.alert("Elige una consulta a borrar");
        return;
      }

      // if (consulta.nombre == "Defecto") {
      //   app.dialog.alert("La consulta por defecto no se puede borrar, elija otra.");
      //   return;
      // }

      const consultaDefecto = self.getConsultaDefecto();

      const data = {
        codigoTabla: self.tableUse.codigo,
        consultasFavoritas: [
          consulta
        ]
      }
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      TablaUsuario.deleteConsulta({data: data}).then(res => {
        app.toast
        .create({
          icon: '<i class="f7-icons">checkmark</i>',
          text: self.$t("common.consultaBorrada"),
          position: "center",
          destroyOnClose: true,
          closeTimeout: 2000
        })
        .open();
        res.consultasFavoritas = [...[consultaDefecto], ...res.consultasFavoritas];
        self.tableUse.consultasFavoritas = res.consultasFavoritas;
        self.$refs.consultasCombo.reload(self.tableUse.consultasFavoritas);
        self.$set(self.$refs.rformConsultas.formData, "consulta", consultaDefecto);
        self.changeConsulta(consultaDefecto);
      }).catch(error => {
        var message = typeof error == "string" ? error : error.message;
        app.dialog.alert(message);
      }).finally(() => espera.cerrar());

    },
    guardarConsulta(nombre) {
      var self = this;
      var app = self.$f7;

      if (!nombre) {
        app.dialog.alert("El nombre es obligatorio");
        return;
      }
      // if (nombre == "Defecto") {
      //   app.dialog.alert("La consulta por defecto no se puede sobreescribir, elija otro nombre.");
      //   return;
      // }
      
      const consultaDefecto = self.getConsultaDefecto();

      const columns = self.getActiveColumns().map(c => c.pathName);
      const funcionesAgregadas = self.getActiveAgregaciones().map(c => c.as);
      const filtro = JSON.stringify(self.getFilterData());
      const order = self.order;
      const orderDir = self.orderDir;

      const data = {
        codigoTabla: self.tableUse.codigo,
        consultasFavoritas: [
          {
            nombre: nombre,
            pathNamesColumnas: columns,
            filtro: filtro,
            order: order,
            orderDir: orderDir,
            funcionesAgregadas: funcionesAgregadas
          }
        ]
      }
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      TablaUsuario.createConsulta({data: data}).then(res => {
        app.toast
        .create({
          icon: '<i class="f7-icons">checkmark</i>',
          text: self.$t("common.consultaGuardada"),
          position: "center",
          destroyOnClose: true,
          closeTimeout: 2000
        })
        .open();
        if (self.$refs.popupGuardarConsulta) {
          self.$refs.popupGuardarConsulta.close();
        }

        if (!res.consultasFavoritas.filter(c => c.nombre == 'Defecto').length) {
          res.consultasFavoritas = [...[consultaDefecto], ...res.consultasFavoritas];
        }

        self.tableUse.consultasFavoritas = res.consultasFavoritas;
        var consulta = res.consultasFavoritas.filter(cf => cf.nombre == nombre)[0];
        self.$refs.consultasCombo.reload(self.tableUse.consultasFavoritas);
        self.$set(self.$refs.rformConsultas.formData, "consulta", consulta);
        self.changeConsulta(consulta, false);
      }).catch(error => {
        var message = typeof error == "string" ? error : error.message;
        app.dialog.alert(message);
      }).finally(() => espera.cerrar());
    },
    onDrop(arr, dropResult) {
      var self = this;
      applyDrag(arr, dropResult);
      self.clearAll();
    },
    getColumnsFiltered: function() {
      const self = this;
      var columns = self.getActiveColumns();
      if (self.searchColumns) {
        var searchs = self.searchColumns && typeof self.searchColumns === 'string' ? self.searchColumns.split(",") : [];
        columns = columns.filter(c => {
          var isSticky = c.opciones && c.opciones.sticky;
          var nombreTrad = self.$t(c.nombre);
          var isFiltered = searchs.some(s => s && s.trim() && nombreTrad.trim().toLowerCase().indexOf(s.trim().toLowerCase()) >= 0);
          return isSticky || isFiltered;
        });
      }
      return columns;
    },
    getActiveColumns: function() {
      const self = this;
      let columns = self.columns.filter(c => c.activaUsuario);
      if (self.filterColumns) {
        columns = self.filterColumns(columns);
      }
      return columns;
    },
    getProjectionsColumns: function() {
      const self = this;
      let columns = self.getActiveColumns().filter(c => !c.disableProjection);
      // // proyectaremos también las columnas indicadas como column.opciones.columnaId para poder usar sus valores en los enlaces de sus urls
      // let columnasIds = self.columns.filter(c => c.opciones && c.opciones.columnaId).map(c => {
      //   let newColumn = {
      //     nombre: "ID",
      //     pathName: c.opciones.columnaId,
      //     tipo: "STRING",
      //     activaUsuario: c.activaUsuario,
      //   };
      //   return newColumn;
      // });
      // columns.concat(columnasIds);
      return columns;
    },
    getActiveAgregaciones: function() {
      const self = this;
      return self.agregaciones.filter(c => c.activaUsuario);
    },
    getAgregacionValor: function(agregacion) {
      const self = this;
      const mandatoryFilter = self.mandatoryFilter;
      // podemos tener en las agregaciones un campo opciones.evalPathName que nos permita evaluar el valor de la agregación
      return self.agregacionesValor.filter(a => a.nombre == agregacion.as).map(item => 
      {
        if (agregacion.opciones && agregacion.opciones.evalPathName) {
          try {
            // Para agregaciones, el contexto es el item del valor de agregación
            const evalFunction = new Function('item', 'return ' + agregacion.opciones.evalPathName);
            return evalFunction(item);
          } catch (error) {
            console.error("Error evaluando el evalPathName: " + error);
          }
        }
        return item.valor;
      })[0];
    },
    getAgregacionCount: function(agregacion) {
      const self = this;
      return self.agregacionesValor.filter(a => a.nombre == agregacion.as).map(a => a.count)[0];
    },
    getActiveColumnsFiltro: function() {
      const self = this;
      if (self.columns) {
        return self.columns.filter(c => c.filtro && c.filtro.activo);
      } else {
        [];
      }
    },
    getActiveColumnsMasivo: function() {
      const self = this;
      if (self.columns) {
        return self.columns.filter(c => c.activaUsuario && c.cambioMasivo && c.cambioMasivo.activo
          && self.puedeCambiarEnMasa(c));
      } else {
        [];
      }
    },
    // Una columna puede acotar su cambio masivo por rol con `cambioMasivo.opciones.roles`: se SIGUE
    // viendo y filtrando, pero no aparece en el popup de cambio masivo de quien no esté en la lista
    // (#205, criterio 5, para el responsable de gestión de cobro del cliente).
    //
    // Va en `opciones` y no como campo propio porque `cambioMasivo` es un `FiltroEMO` de
    // digitaltpm-core, que no tiene `roles` y no se toca. Sin la clave, la columna se comporta
    // exactamente como hasta ahora: esto no cambia ninguna de las que ya existen.
    //
    // El backend lo vuelve a comprobar en el `updateMany`: esto solo evita ofrecer un botón que
    // acabaría en un 403.
    puedeCambiarEnMasa: function(column) {
      const roles = column.cambioMasivo.opciones && column.cambioMasivo.opciones.roles;
      if (!roles || !roles.length) {
        return true;
      }
      const user = Utils.getUser();
      if (!user || !user.roles) {
        return false;
      }
      return user.roles.indexOf("ADMIN") > -1 || roles.some(r => user.roles.indexOf(r) > -1);
    },
    hasMapFilterColumns: function() {
      const self = this;
      return self.getMapFilterColumns().length > 0;
    },
    isMapFilterColumnActive: function(column) {
      const self = this;
      const conds = self.getMapFilterConditionsWithValue();
      const pathName = self.getFiltroPathName(column);
      if (column.filtro.tipo == "FECHA" || column.filtro.tipo == "FECHAHORA" || column.filtro.tipo == "IMPORTE") {
        return !!conds[pathName + "Desde"] || !!conds[pathName + "Hasta"] || !!conds[pathName + "FechaVacia"] || !!conds[pathName + "FechaRellena"];
      } else if (column.filtro.tipo == "NUMERO") {
        return conds[pathName] != undefined || !!conds[pathName + "CampoVacio"] || !!conds[pathName + "CampoRelleno"];
      } else if (column.filtro.tipo == "BOOLEAN") {
        return !!conds[pathName + "BOOLEANSI"] || !!conds[pathName + "BOOLEANNO"] || !!conds[pathName + "CampoVacio"] || !!conds[pathName + "CampoRelleno"];
      }
      return !!conds[pathName] || !!conds[pathName + "CampoVacio"] || !!conds[pathName + "CampoRelleno"];
    },
    getMapFilterColumns: function() {
      const self = this;
      const mapa = self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa;
      const configuredFilters = mapa && Array.isArray(mapa.filtros) ? mapa.filtros : [];
      if (!configuredFilters.length || !Array.isArray(self.columns)) {
        return [];
      }

      return configuredFilters.map(filterPath => {
        const pathName = typeof filterPath === 'string' ? filterPath : filterPath && filterPath.pathName;
        if (!pathName) {
          return null;
        }
        return self.columns.find(column => {
          const visiblePath = self.getCleanPathName(column.pathName);
          const filterPathName = self.getCleanPathName(column.filtro && column.filtro.pathName);
          return column.filtro && column.filtro.activo && (visiblePath === pathName || filterPathName === pathName);
        });
      }).filter((column, index, arr) => column && arr.indexOf(column) === index);
    },
    removeMapFilter(column) {
      const self = this;
      var filterItem = self.$refs['map-filter-item-' + self.getFiltroPathName(column)];
      if (filterItem && Array.isArray(filterItem)) {
        filterItem.forEach(f => {
          f.cleanData();
        });
      } else if (filterItem) {
        filterItem.cleanData();
      }
      if (self.$refs.rformMapFilters) {
        self.applyMapFilters(self.$refs.rformMapFilters.formData);
      } else {
        self.applyMapFilters({});
      }
    },
    mostrarBadgeFiltros: function() {
      const self = this;
      return self.mostrarBadgeFilters && self.getActiveConditions().length !== 0;
    },
    getActiveConditions() {
      const self = this;
      return Object.entries(self.conditions).filter(([key, value]) => {
        const includeNoCounter = self.filtersNoCounters.includes(key);
        const includeMesOrVacia = (!key.endsWith('FechaRellena') || (key.endsWith('FechaRellena') && value)) && (!key.endsWith('FechaVacia') || (key.endsWith('FechaVacia') && value)) && !key.endsWith('MesActual') && !key.endsWith('SemanaActual') && !key.endsWith('AnyoActual') && !key.endsWith('DiaActual')  && (!key.endsWith('CampoVacio') || (key.endsWith('CampoVacio') && value))  && (!key.endsWith('CampoRelleno') || (key.endsWith('CampoRelleno') && value));
        const includeBoolean = (!key.endsWith('BOOLEANSI') || (key.endsWith('BOOLEANSI') && value)) && (!key.endsWith('BOOLEANNO') || (key.endsWith('BOOLEANNO') && value));
        const objectNull = value != null && typeof value != 'undefined' && value != '';
        const arrayEmpty = !Array.isArray(value) || value.length;
        return !includeNoCounter && objectNull && arrayEmpty && includeMesOrVacia && includeBoolean;
      });
    },
    getConditionsWithValue() {
      const self = this;
      var conds = JSON.parse(JSON.stringify(self.conditions));
      Object.entries(conds).forEach(([key, value]) => {
        if (typeof value == 'string') {
          conds[key] = value.trim();
        }
        const objectNull = value != null && typeof value != 'undefined' && (value != '' || typeof value == 'number');
        const arrayEmpty = !Array.isArray(value) || value.length;
        if (!objectNull || !arrayEmpty) {
          delete conds[key];
        }
      });
      return conds;
    },
    changeConsulta: function(consulta, clearData = true) {
      const self = this;
      if (clearData) {
        self.clearAll();
      }
      if (consulta) {
        var filtro = self.ignoreTableFilters ? {} : consulta.filtro;
        if (filtro && typeof filtro == "string") {
          try {
            filtro = JSON.parse(filtro);
          } catch (e) {
            filtro = {};
          }
        }
        self.loadFilters(filtro);

        self.order = consulta.order;
        self.orderDir = consulta.orderDir;

        if (consulta.pathNamesColumnas) {
          const noActiveColumns = self.columns.filter(c => consulta.pathNamesColumnas.indexOf(c.pathName) <= -1);

          const activeColumns = consulta.pathNamesColumnas.map(pn => {
            var column = self.columns.filter(c => c.pathName == pn)[0];
            if (column) {
              column.activaUsuario = true;
              return column;
            }
            return;
          }).filter(c => c);

          noActiveColumns.forEach(c => c.activaUsuario = false);

          self.columns = [...activeColumns, ...noActiveColumns];
        }
        if (consulta.funcionesAgregadas) {
          const noActiveAgregaciones = self.agregaciones.filter(c => consulta.funcionesAgregadas.indexOf(c.as) <= -1);

          const activeAgregaciones = consulta.funcionesAgregadas.map(pn => {
            var func = self.agregaciones.filter(c => c.as == pn)[0];
            if (func) {
              func.activaUsuario = true;
              return func;
            }
            return;
          }).filter(c => c);

          noActiveAgregaciones.forEach(c => c.activaUsuario = false);

          self.agregaciones = [...activeAgregaciones, ...noActiveAgregaciones];
        }
      } else {
        self.clearFilter();
        self.columns = JSON.parse(JSON.stringify(self.initialColumns));
      }
	   
      self.forceUpdate(); 
    },
    loadFilters(filtro) {
      const self = this;
      if (self.$refs.rformfilter) {
        self.$refs.rformfilter.loadFilters(filtro);
      } else if (self.$refs.rformfilterHeader) {
        self.$refs.rformfilterHeader.loadFilters(filtro);
      }
    },
    getFilterData() {
      const self = this;
      if (self.$refs.rformfilter) {
        return self.$refs.rformfilter.formData;
      }
      else if (self.$refs.rformfilterHeader) {
        return self.$refs.rformfilterHeader.formData;
      }
    },
    clearFilter() {
      const self = this;
      if (self.$refs.rformfilter) {
        self.$refs.rformfilter.clear();
      }else if (self.$refs.rformfilterHeader) {
        self.$refs.rformfilterHeader.clear();
      }
    },
    forceUpdate() {
      const self = this;
      self.$forceUpdate(); 
      if (self.$refs.rformfilter) {
        self.$refs.rformfilter.$forceUpdate();
      }else if (self.$refs.rformfilterHeader) {
        self.$refs.rformfilterHeader.$forceUpdate();
      }
    },
    submitFilterForm() {
      const self = this;
      if (self.$refs.rformfilter) {
        self.$refs.rformfilter.submit();
      }else if (self.$refs.rformfilterHeader) {
        self.$refs.rformfilterHeader.submit();
      }
    },
    onPressEnter() {
      const self = this;
      if (self.$refs.rformfilter) {
        self.$refs.btnSearchFilterForm.$el.click();
      }else if (self.$refs.rformfilterHeader) {
        self.$refs.btnSearchFilterFormHeader.$el.click();
      }
    },
    getConsultaDefecto: function() {
      const self = this;
      let consDef = self.tableUse ? self.tableUse.consultasFavoritas.filter(c => c.nombre == 'Defecto')[0] : null;
      if (self.ignoreTableFilters && consDef) {
        consDef.filter = {};
      }
      return consDef;
    },
    getTextFiltrosActivos: function() {
      const self = this;
      const list = Object.entries(self.conditions)
        .filter(([key, value]) => key !== 'historificar' && (!key.endsWith('BOOLEANNO') || (key.endsWith('BOOLEANNO') && value)) && (!key.endsWith('BOOLEANSI') || (key.endsWith('BOOLEANSI') && value)) && (!key.endsWith('FechaRellena') || (key.endsWith('FechaRellena') && value)) && (!key.endsWith('FechaVacia') || (key.endsWith('FechaVacia') && value)) && (!key.endsWith('CampoVacio') || (key.endsWith('CampoVacio') && value))  && (!key.endsWith('CampoRelleno') || (key.endsWith('CampoRelleno') && value)) && !key.endsWith('MesActual') && !key.endsWith('SemanaActual') && !key.endsWith('AnyoActual') && !key.endsWith('DiaActual') && !self.filtersNoCounters.includes(key) && value != null && typeof value != 'undefined' && (value != '' || typeof value == 'number'));
      var str = " | ";
      const columnas = self.tableUse.columnas;
      const prefiltros = self.tableUse.prefiltros;
      list.forEach(([nombre, valor]) => {
        var suffix = "";
        if (nombre.endsWith("Desde")) {
          nombre = nombre.substring(0, nombre.indexOf("Desde"));
          suffix = "Desde";
        } else if (nombre.endsWith("Hasta")) {
          nombre = nombre.substring(0, nombre.indexOf("Hasta"));
          suffix = "Hasta";
        } else if (nombre.endsWith("FechaVacia")) {
          nombre = nombre.substring(0, nombre.indexOf("FechaVacia"));
          suffix = "Vacía";
        } else if (nombre.endsWith("FechaRellena")) {
          nombre = nombre.substring(0, nombre.indexOf("FechaRellena"));
          suffix = "Rellena";
        } else if (nombre.endsWith("CampoVacio")) {
          nombre = nombre.substring(0, nombre.indexOf("CampoVacio"));
          suffix = "Vacío";
        } else if (nombre.endsWith("CampoRelleno")) {
          nombre = nombre.substring(0, nombre.indexOf("CampoRelleno"));
          suffix = "Relleno";
        } else if (nombre.endsWith("BOOLEANSI")) {
          nombre = nombre.substring(0, nombre.indexOf("BOOLEANSI"));
        } else if (nombre.endsWith("BOOLEANNO")) {
          nombre = nombre.substring(0, nombre.indexOf("BOOLEANNO"));
          valor = !valor;
        } else if (nombre == 'andList') {
          nombre = 'AND';
          // Formatear el array de condiciones
          if (Array.isArray(valor)) {
            valor = valor.map(condicion => {
              let texto = condicion.nombre;
              if (condicion.operacion === 'EQUALS') {
                texto += `: '${condicion.valor}'`;
              } else if (condicion.operacion === 'IN') {
                texto += ` IN [${condicion.valor}]`;
              } else {
                texto += ` ${condicion.operacion}: '${condicion.valor}'`;
              }
              return texto;
            }).join(', ');
            valor = `[ ${valor} ]`;
          }
        }  else if (nombre == 'orList') {
          nombre = 'OR';
          // Formatear el array de condiciones
          if (Array.isArray(valor)) {
            valor = valor.map(condicion => {
              let texto = condicion.nombre;
              if (condicion.operacion === 'EQUALS') {
                texto += `: '${condicion.valor}'`;
              } else if (condicion.operacion === 'IN') {
                texto += ` IN [${condicion.valor}]`;
              } else {
                texto += ` ${condicion.operacion}: '${condicion.valor}'`;
              }
              return texto;
            }).join(', ');
            valor = `[ ${valor} ]`;
          }
        }
        const columna = columnas.filter(c => self.getFiltroPathName(c) == nombre)[0];
        if (columna && columna.filtro) {
          nombre = self.$t(columna.nombre);
          switch (columna.filtro.tipo) {
            case "FECHA":
            case "FECHAHORA":
              valor = DateUtils.dateFormat(valor, columna.formato);
              break;
            case "SELECT":
            case "MULTISELECT":
              if (columna.mapValueFromFilterItems && !suffix) {
                const itemList = columna.filtro.items;
                valor = valor.map(v => {
                  const item = itemList.filter(i => i.valor == v)[0];
                  if (item) {
                    return self.$t(item.nombre);
                  }
                  return v;
                });
              }
              break;
            default:
              break;
          }
          
        }

        if (Array.isArray(valor)) {
          valor = valor.join(", ");
        }

        str = str + nombre + (suffix ? " " + suffix : "") + ": " + (typeof valor == 'boolean' ? (valor ? self.$t('common.yes') : self.$t('common.no')): valor);
        str = str + " | "
      });
      return str;
    },
    getColorItem: function(item, column) {
      const self = this;
      var context = self.getValorOriginalItem(item, column);
      var contextEval = self.getValorItem(item, column);
      const colores = column.colores;
      if (colores && colores.length) {
        let color = colores.filter(i => i.nombre == context || i.nombre == contextEval)[0];
        if (color) {
          return color.valor;
        } else {
          // Si no hay color definido, devolvemos el color por defecto
          color = colores.filter(i => i.nombre == 'DEFAULT')[0];
          return color ? color.valor : "";
        }
      }
    },
    getValorItem: function(item, column) {
      const self = this;
      const mandatoryFilter = self.mandatoryFilter;
      if(column.opciones && column.opciones.evalPathName){
        try {
          // // Crear una función que tenga acceso al item en su contexto
          // const evalFunction = new Function('item', 'column', 'return ' + column.opciones.evalPathName);
          // return evalFunction(item, column);
          return eval(column.opciones.evalPathName);
        } catch (error) {
          console.error("Error evaluando el evalPathName: " + error);
          return "";
        }
      }
      var context = self.getValorOriginalItem(item, column);
      if (column.mapValueFromFilterItems) {
        const itemList = column.filtro.items;
        const valorProp = column.filtro.idProp || "valor";
        const item = itemList.filter(i => i[valorProp] == context)[0];
        if (item) {
          context = self.$t(item.nombre);
        }
      }
      if (Array.isArray(context) && !!!context.length) {
        return false;
      }
      return context;
    },
    getValor: function(item, pathName) {
      const self = this;
      const mandatoryFilter = self.mandatoryFilter;
      if(pathName){
        try {
          console.log("recuperando el valor de  " + pathName);
          return eval('item.'+pathName);
        } catch (error) {
          console.log("Error recuperando el valor de " + pathName + " " + error);
          return "";
        }
      }
    },
    itemStringify: function(item, column) {
      const self = this;
      var elementColumn = self.getValorOriginalItem(item, column);

      if (column.tipo != 'LISTA' || (Array.isArray(elementColumn) && !!!elementColumn.length) || !!!column.opciones || !!!column.opciones.stringifyField ) {
        return false;
      } else {
        var strResult = elementColumn.map(element => {
          let algo = "";
          const stringifyField = column.opciones.stringifyField;
          
          // Si es true, devolver el elemento completo
          if (stringifyField === true) {
            return element;
          }
          
          // Si es string, intentar diferentes estrategias
          if (typeof stringifyField === 'string') {
            // Estrategia 1: Intentar evaluar como expresión (para casos como "element.docNum")
            if (self.isEvaluableExpression(stringifyField)) {
              try {
                const evalFunction = new Function('element', 'return ' + stringifyField);
                algo = evalFunction(element);
                if (algo !== undefined && algo !== null) {
                  return algo;
                }
              } catch (e) {
                // Si falla la evaluación, continuar con las siguientes estrategias
              }
            }
            
            // Estrategia 2: Acceso directo como propiedad (para casos como "docNum")
            if (element && element.hasOwnProperty(stringifyField)) {
              algo = element[stringifyField];
              if (algo !== undefined && algo !== null) {
                return algo;
              }
            }
            
            // Estrategia 3: Acceso anidado usando notación de punto (para casos como "insp.docnum")
            if (stringifyField.includes('.')) {
              try {
                algo = self.getNestedProperty(element, stringifyField);
                if (algo !== undefined && algo !== null) {
                  return algo;
                }
              } catch (e) {
                // Si falla, continuar
              }
            }
          }
          
          // Si nada funcionó, devolver string vacío
          return "";
        }).join();
        
        let strLength = column.opciones && column.opciones.stringifyLength ? column.opciones.stringifyLength : 11;
        return strResult.length > strLength ? strResult.substring(0, strLength) + ' ...' : strResult;
      }
    },

    // Función auxiliar para determinar si una expresión es evaluable
    isEvaluableExpression: function(expression) {
      // Verificar si contiene palabras clave que indican que es una expresión evaluable
      const evaluableKeywords = ['element.', 'item.', 'this.', '(', ')', '+', '-', '*', '/', '&&', '||'];
      return evaluableKeywords.some(keyword => expression.includes(keyword));
    },

    // Función auxiliar para acceder a propiedades anidadas
    getNestedProperty: function(obj, path) {
      return (path && typeof path === 'string' ? path.split('.') : []).reduce((current, key) => {
        return current && current[key] !== undefined ? current[key] : undefined;
      }, obj);
    },
    getCleanPathName(pathName) {
      if (!pathName) {
        return '';
      }
      if (pathName.indexOf("|") > -1) {
        pathName = pathName.split("|")[0];
      }
      if (pathName.indexOf("##") > -1) {
        pathName = pathName.replaceAll("##", ".");
      }
      return pathName;
    },
    getValorOriginalItem: function(item, column) {
      const self = this;
      var pathName = self.getCleanPathName(column.pathName);
      var prefixVal = null;
      if (column.opciones && column.opciones.prefixPathName) {
        var prefixPathName = self.getCleanPathName(column.opciones.prefixPathName);
        var prefixNamespaces = prefixPathName ? prefixPathName.split(".") : [];
        prefixVal = self.getValorObjectByNamespaces(item, prefixNamespaces, false)
      }
      var namespaces = pathName.split(".");
      var context = self.getValorObjectByNamespaces(item, namespaces, column.tipo == "LISTA")
      return prefixVal ? prefixVal + ' - ' + context : context;
    },
    getValorObjectByNamespaces(item, namespaces, returnArrayIfExists = false) {
      var context = item;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        if (typeof context == "undefined" || context == null) context = {};
        if (!Array.isArray(context) || !returnArrayIfExists) {
          context = context[namespaces[i]];
        }
      }
      return context;
    },
    getFiltroPathName: function(column) {
      if (!column) return "";
      var pathName = (column.filtro && column.filtro.pathName) || column.pathName;
      if (!pathName) return "";
      return pathName.replaceAll(".", "##");
    },
    getFilterFromLocalStorage: function() {
      var self = this;
      var objReturn = {};
      if (self.filtersName) {
        objReturn = localStorage.getItem("filter-" + self.filtersName);
      }
      if (objReturn && typeof objReturn == "string") {
        try {
          objReturn = JSON.parse(objReturn);
        } catch (e) {
          objReturn = {};
        }
      }
      return objReturn || {};
    },
    reload() {
      var self = this;
      if (self.dbAdapter && typeof self.dbAdapter.resetCache == "function") {
        self.dbAdapter.resetCache();
      }
      self.invalidateMapDataCache('reload');
      self.refresh();
    },
    invalidateMapDataCache(reason = '') {
      const self = this;
      self.allMapItemsLoaded = false;
      self.$set(self, 'mapData', []);
      self.$set(self, 'mapFilteredData', []);
      if (reason) {
        console.log(`[MAP] Cache invalidada: ${reason}`);
      }
    },
    getMapFilterConditionsWithValue() {
      const self = this;
      var conds = JSON.parse(JSON.stringify(self.mapFilterConditions || {}));
      Object.entries(conds).forEach(([key, value]) => {
        if (typeof value == 'string') {
          conds[key] = value.trim();
        }
        const objectNull = value != null && typeof value != 'undefined' && (value != '' || typeof value == 'number');
        const arrayEmpty = !Array.isArray(value) || value.length;
        if (!objectNull || !arrayEmpty) {
          delete conds[key];
        }
      });
      return conds;
    },
    clearMapFilters() {
      const self = this;
      if (self.$refs.rformMapFilters) {
        self.$refs.rformMapFilters.clear();
      }
      self.mapFilterConditions = {};
      self.syncMapFilteredData();
    },
    applyMapFilters(filter) {
      const self = this;
      self.mapFilterConditions = filter ? { ...filter } : {};
      self.syncMapFilteredData();
    },
    syncMapFilteredData() {
      const self = this;
      self.$set(self, 'mapFilteredData', self.filterMapDataLocally(self.mapData));
    },
    filterMapDataLocally(items = []) {
      const self = this;
      const conditions = self.getMapFilterConditionsWithValue();
      const columns = self.getMapFilterColumns();
      if (!columns.length || !Object.keys(conditions).length) {
        return Array.isArray(items) ? [...items] : [];
      }
      return (Array.isArray(items) ? items : []).filter(item => columns.every(column => self.matchesMapFilter(item, column, conditions)));
    },
    isMapFilterEmpty(value) {
      if (value === null || typeof value === 'undefined') {
        return true;
      }
      if (typeof value === 'string') {
        return value.trim() === '';
      }
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      return false;
    },
    normalizeMapFilterBoolean(value) {
      if (typeof value === 'boolean') {
        return value;
      }
      if (typeof value === 'number') {
        return value !== 0;
      }
      if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        if (['true', '1', 'si', 'sí', 'yes'].includes(normalized)) {
          return true;
        }
        if (['false', '0', 'no'].includes(normalized)) {
          return false;
        }
      }
      return null;
    },
    normalizeMapFilterDate(value) {
      if (!value) {
        return null;
      }
      const date = value instanceof Date ? value : new Date(value);
      return Number.isNaN(date.getTime()) ? null : date;
    },
    getMapFilterItemValue(item, column) {
      const self = this;
      const rawPath = self.getCleanPathName((column.filtro && column.filtro.pathName) || column.pathName);
      let itemValue = self.getNestedProperty(item, rawPath);

      if (typeof itemValue === 'undefined' && rawPath) {
        if (rawPath.endsWith('._id')) {
          itemValue = self.getNestedProperty(item, rawPath.replace(/\._id$/, '.id'));
        } else if (rawPath.endsWith('.id')) {
          itemValue = self.getNestedProperty(item, rawPath.replace(/\.id$/, '._id'));
        }
      }

      if (typeof itemValue === 'undefined' && column && column.pathName) {
        itemValue = self.getNestedProperty(item, self.getCleanPathName(column.pathName));
      }

      if (itemValue && typeof itemValue === 'object' && !Array.isArray(itemValue)) {
        if (typeof itemValue._id !== 'undefined') {
          return itemValue._id;
        }
        if (typeof itemValue.id !== 'undefined') {
          return itemValue.id;
        }
      }

      return itemValue;
    },
    matchMapFilterValue(itemValue, filterValue, operation, tipo) {
      const self = this;
      if (self.isMapFilterEmpty(filterValue)) {
        return true;
      }
      if (operation === 'IN' || operation === 'IN_OBJECT_ID') {
        const selectedValues = Array.isArray(filterValue) ? filterValue.map(v => String(v)) : [String(filterValue)];
        if (itemValue && typeof itemValue === 'object' && !Array.isArray(itemValue)) {
          itemValue = itemValue._id || itemValue.id || itemValue;
        }
        if (Array.isArray(itemValue)) {
          return itemValue.map(v => {
            if (v && typeof v === 'object') {
              return String(v._id || v.id || v);
            }
            return String(v);
          }).some(v => selectedValues.includes(v));
        }
        return selectedValues.includes(String(itemValue));
      }
      if (tipo === 'NUMERO' || tipo === 'IMPORTE') {
        const numericItem = Number(itemValue);
        const numericFilter = Number(filterValue);
        if (Number.isNaN(numericItem) || Number.isNaN(numericFilter)) {
          return false;
        }
        return numericItem === numericFilter;
      }
      const normalizedItem = Array.isArray(itemValue) ? itemValue.join(', ') : String(itemValue || '');
      const normalizedFilter = Array.isArray(filterValue) ? filterValue.join(', ') : String(filterValue || '');
      if (operation === 'LIKE_IGNORE_CASE') {
        return normalizedItem.toLowerCase().includes(normalizedFilter.toLowerCase());
      }
      return normalizedItem === normalizedFilter;
    },
    matchesMapFilter(item, column, conditions) {
      const self = this;
      const pathName = self.getFiltroPathName(column);
      const itemValue = self.getMapFilterItemValue(item, column);
      const tipo = column.filtro && column.filtro.tipo;
      const operation = column.filtro && column.filtro.operation;

      if (tipo === 'FECHA' || tipo === 'FECHAHORA') {
        const vacia = !!conditions[pathName + 'FechaVacia'];
        const rellena = !!conditions[pathName + 'FechaRellena'];
        if (vacia) {
          return self.isMapFilterEmpty(itemValue);
        }
        if (rellena && self.isMapFilterEmpty(itemValue)) {
          return false;
        }
        const dateValue = self.normalizeMapFilterDate(itemValue);
        const desde = self.normalizeMapFilterDate(conditions[pathName + 'Desde']);
        const hasta = self.normalizeMapFilterDate(conditions[pathName + 'Hasta']);
        if ((desde || hasta) && !dateValue) {
          return false;
        }
        if (desde && dateValue < desde) {
          return false;
        }
        if (hasta && dateValue > hasta) {
          return false;
        }
        return true;
      }

      if (tipo === 'IMPORTE') {
        const vacia = !!conditions[pathName + 'FechaVacia'];
        const rellena = !!conditions[pathName + 'FechaRellena'];
        if (vacia) {
          return self.isMapFilterEmpty(itemValue);
        }
        if (rellena && self.isMapFilterEmpty(itemValue)) {
          return false;
        }
        const numericValue = Number(itemValue);
        const desde = conditions[pathName + 'Desde'] != null && conditions[pathName + 'Desde'] !== '' ? Number(conditions[pathName + 'Desde']) : null;
        const hasta = conditions[pathName + 'Hasta'] != null && conditions[pathName + 'Hasta'] !== '' ? Number(conditions[pathName + 'Hasta']) : null;
        if ((desde !== null || hasta !== null) && Number.isNaN(numericValue)) {
          return false;
        }
        if (desde !== null && numericValue < desde) {
          return false;
        }
        if (hasta !== null && numericValue > hasta) {
          return false;
        }
        return true;
      }

      if (tipo === 'BOOLEAN') {
        const vacio = !!conditions[pathName + 'CampoVacio'];
        const relleno = !!conditions[pathName + 'CampoRelleno'];
        if (vacio) {
          return self.isMapFilterEmpty(itemValue);
        }
        if (relleno && self.isMapFilterEmpty(itemValue)) {
          return false;
        }
        const booleanSI = !!conditions[pathName + 'BOOLEANSI'];
        const booleanNO = !!conditions[pathName + 'BOOLEANNO'];
        if ((booleanSI && booleanNO) || (!booleanSI && !booleanNO)) {
          return true;
        }
        const booleanValue = self.normalizeMapFilterBoolean(itemValue);
        if (booleanValue === null) {
          return false;
        }
        return booleanSI ? booleanValue === true : booleanValue === false;
      }

      const vacio = !!conditions[pathName + 'CampoVacio'];
      const relleno = !!conditions[pathName + 'CampoRelleno'];
      if (vacio) {
        return self.isMapFilterEmpty(itemValue);
      }
      if (relleno && self.isMapFilterEmpty(itemValue)) {
        return false;
      }
      return self.matchMapFilterValue(itemValue, conditions[pathName], operation, tipo);
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    primaryEfectivo() {
      const self = this;
      return (self.ejecutorActivo && self.ejecutorActivo.accion && self.ejecutorActivo.accion.primary)
        ? self.ejecutorActivo.accion.primary
        : self.primary;
    },
    mostrarCheck(item) {
      const self = this;
      return !!self.ejecutorActivo || self.funcShowCheck(item);
    },
    activarEjecutor: async function(ejecutor) {
      const self = this;
      self.ejecutorActivo = ejecutor;
      self.selected = {};
      self.dbAdapterEjecutor = null;
      const nombreAdapter = ejecutor && ejecutor.accion && ejecutor.accion.dbAdapter;
      if (nombreAdapter) {
        const cargador = DB_ADAPTERS_EJECUTOR[nombreAdapter];
        if (!cargador) {
          console.error("[ejecutor] dbAdapter '" + nombreAdapter + "' no está registrado en DB_ADAPTERS_EJECUTOR (rDynamicList.vue).");
          self.$f7.dialog.alert("El adaptador '" + nombreAdapter + "' no está registrado para el ejecutor '" + ejecutor.nombre + "'.");
          self.ejecutorActivo = null;
          return;
        }
        try {
          const modulo = await cargador();
          self.dbAdapterEjecutor = modulo.default;
        } catch (e) {
          console.error("[ejecutor] Error cargando dbAdapter '" + nombreAdapter + "':", e);
          self.$f7.dialog.alert("No se ha podido cargar el adaptador '" + nombreAdapter + "' para el ejecutor '" + ejecutor.nombre + "'. Mira la consola (F12) para el detalle.");
          self.ejecutorActivo = null;
        }
      }
    },
    desactivarEjecutor: function() {
      const self = this;
      self.ejecutorActivo = null;
      self.dbAdapterEjecutor = null;
      self.selected = {};
    },
    getPrimary(data) {
      var self = this;
      var prim = "";
      self.primaryEfectivo().forEach((p, index) => {
        var namespaces = p && typeof p === 'string' ? p.split(".") : [];
        if (prim) {
          prim = prim + "-";
        }
        // prim = prim + p;
        var val = this.getValorObjectByNamespaces(data, namespaces);
        // Manejar valores undefined/null para evitar keys duplicadas
        if (val === undefined || val === null) {
          val = `_${p}_${index}_null`;
        }
        prim = prim + val;
      })
      return prim;
    },
    getPrimaryObject(data) {
      var self = this;
      var prim = {};
      self.primary.forEach(p => {
        var val = this.getValorObjectByNamespaces(data, p && typeof p === 'string' ? p.split(".") : []);
        prim[p] = val;
      })
      return prim;
    },
    toggleSelect: function(data, value) {
      const self = this;
      var dataSelected = self.getPrimary(data);
      if (value) {
        self.$set(self.selected, dataSelected, data);
      } else {
        self.$delete(self.selected, dataSelected);
      }
      self.$emit("select", Object.assign({}, self.selected));
    },
    toggleSelectAll: function(value) {
      const self = this;
      if (value) {
        self.vlData.items.forEach(function(data) {
          if (self.mostrarCheck(data)) {
            self.$set(self.selected, self.getPrimary(data), data);
          }
        });
      } else {
        self.selected = {};
      }
    },
    paramsGetRemoteData: function() {
      const self = this;
      var [conds, filterAndList, funcionesAgregadas] = self.getFilterAndList();
      if (!!filterAndList && !!filterAndList.length) {
        conds.andList = filterAndList;
      }
      if (!!funcionesAgregadas && !!funcionesAgregadas.length) {
        conds.funcionesAgregadas = funcionesAgregadas;
      }
      if (!!!self.order) {
        self.order = "creationDate";
      }
      let params = {
        filter: {
          ...conds,
          paginationFilterSort: self.paginationFilterSort,
          primary: self.primary,
        },
        limit: self.rowsPerPageUsed == -1 ? null : self.rowsPerPageUsed,
        offset: self.rowsPerPageUsed == -1 ? null : self.rowsPerPageUsed * (self.page - 1),
        page: self.page,
        complete: self.complete,
        projection: self.getProjectionFields(conds),
        order: self.getCleanPathName(self.order),
        orderDir: self.orderDir,
      };
      // gestionar la paginación cuando tengamos la propiedad paginationFilterSort a true y estamos ordenando por algo distinto del id
      if (self.paginationFilterSort) {
        // Si self.vlData.items tiene datos, nos quedamos con el último
        let ultimoCampoSort;
        let ultimoId;
        if(self.vlData.items.length > 0) {
          const ultimoItem = self.vlData.items[self.vlData.items.length - 1];
          let valorCampoSort = Utils.getNestedProperty(ultimoItem, self.order);
          // Si ultimoCampoSort parece una fecha, tratamos de convertirlo a fecha
          if(typeof valorCampoSort == 'string' && /^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(valorCampoSort)) {
            valorCampoSort = new Date(valorCampoSort);
          }
          if (self.order && (valorCampoSort === undefined || valorCampoSort === null)) {
            // El último item no trae el campo de ordenación (p.ej. el DTO no lo expone):
            // sin ese valor el backend construye un keyset incompleto (solo primary) que
            // repite/omite filas. En ese caso paginamos por offset clásico.
          } else {
            delete params.offset;
            params.filter.ultimoCampoSort = valorCampoSort;
            params.filter.ultimoId = self.getPrimaryObject(ultimoItem);
          }
        }
        // si reiniciamos la búsqueda, borramos el valor de ultimoCampoSort y ultimoId
        if (self.page == 1) {
          // borramos el campo ultimoCampoSort y ultimoId
          delete params.filter.ultimoCampoSort;
          delete params.filter.ultimoId;
        }
      }
      return params;
    },
    getFilterAndList: function() {
      const self = this;
      var conds = self.getConditionsWithValue();
      var filterAndList = self.getActiveColumnsFiltro().filter(c => {
        const pathName = self.getFiltroPathName(c);
        if (c.filtro.tipo == "FECHA" || c.filtro.tipo == "FECHAHORA" || c.filtro.tipo == "IMPORTE") {
          return !!conds[pathName + "Desde"] || !!conds[pathName + "Hasta"] || !!conds[pathName + "FechaVacia"] || !!conds[pathName + "FechaRellena"];
        } else if (c.filtro.tipo == "NUMERO") {
          return conds[pathName] != undefined || !!conds[pathName + "CampoVacio"] || !!conds[pathName + "CampoRelleno"];
        } else if (c.filtro.tipo == "BOOLEAN") {
          return !!conds[pathName + "BOOLEANSI"] || !!conds[pathName + "BOOLEANNO"] || !!conds[pathName + "CampoVacio"] || !!conds[pathName + "CampoRelleno"];
        } else {
          return !!conds[pathName] || !!conds[pathName + "CampoVacio"] || !!conds[pathName + "CampoRelleno"] ;
        }
      }).filter(c => {
        if (!!c.filtro.operation) {
          const pathName = self.getFiltroPathName(c);
          if (c.filtro.tipo == "FECHA" || c.filtro.tipo == "FECHAHORA" || c.filtro.tipo == "IMPORTE") {
            c.filtro.desde = conds[pathName + "Desde"];
            c.filtro.hasta = conds[pathName + "Hasta"];
            c.filtro.vacia = conds[pathName + "FechaVacia"];
            c.filtro.rellena = conds[pathName + "FechaRellena"];
            delete conds[pathName + "Desde"];
            delete conds[pathName + "Hasta"];
            delete conds[pathName + "FechaVacia"];
            delete conds[pathName + "FechaRellena"];
          } else if (c.filtro.tipo == "BOOLEAN") {
            c.filtro.booleanSI = conds[pathName + "BOOLEANSI"];
            c.filtro.booleanNO = conds[pathName + "BOOLEANNO"];
            c.filtro.vacio = conds[pathName + "CampoVacio"];
            c.filtro.relleno = conds[pathName + "CampoRelleno"];
            delete conds[pathName + "BOOLEANSI"];
            delete conds[pathName + "BOOLEANNO"];
            delete conds[pathName + "CampoVacio"];
            delete conds[pathName + "CampoRelleno"];
          } else {
            c.filtro.valor = conds[pathName];
            c.filtro.vacio = conds[pathName + "CampoVacio"];
            c.filtro.relleno = conds[pathName + "CampoRelleno"];
            delete conds[pathName];
            delete conds[pathName + "CampoVacio"];
            delete conds[pathName + "CampoRelleno"];
          } 
          return true;
        }
        return false;
      }).flatMap(c => {
        const pathName = self.getCleanPathName(self.getFiltroPathName(c));
        var arr = [];
        if (c.filtro.tipo == "FECHA" || c.filtro.tipo == "FECHAHORA" || c.filtro.tipo == "IMPORTE") {
          if (!!c.filtro.desde) {
            arr.push(
              {
                nombre: pathName,
                valor: c.filtro.tipo == "FECHA" || c.filtro.tipo == "FECHAHORA" ? new Date(c.filtro.desde) : c.filtro.desde,
                operacion: "GTE",
                subOperation: c.filtro.subOperation,
                function: c.filtro.function
              }
            );
          }
          if (!!c.filtro.hasta) {
            arr.push(
              {
                nombre: pathName,
                valor: c.filtro.tipo == "FECHA" ? new Date(c.filtro.hasta) : c.filtro.hasta,
                operacion: "LTE",
                subOperation: c.filtro.subOperation,
                function: c.filtro.function
              }
            );
          }
          if (!!c.filtro.vacia) {
            arr.push(
              {
                nombre: pathName,
                valor: true,
                operacion: "NOT_EXISTS",
                subOperation: c.filtro.subOperation,
                function: c.filtro.function
              }
            );
          }
          if (!!c.filtro.rellena) {
            arr.push(
              {
                nombre: pathName,
                valor: true,
                operacion: "EXISTS",
                subOperation: c.filtro.subOperation,
                function: c.filtro.function
              }
            );
          }
          
        } else if (c.filtro.tipo == "BOOLEAN") {
          if (!!c.filtro.vacio || !!c.filtro.relleno) {
            arr.push(
              {
                nombre: pathName,
                valor: true,
                operacion: !!c.filtro.vacio ? "NOT_EXISTS" : "EXISTS",
                subOperation: c.filtro.subOperation,
                function: c.filtro.function
              }
            );
          }else if ((!!c.filtro.booleanSI && !!c.filtro.booleanNO) || (!!!c.filtro.booleanSI && !!!c.filtro.booleanNO)) {
          } else {
            if (!!c.filtro.booleanSI) {
              arr.push({
                nombre: pathName,
                valor: true,
                operacion: c.filtro.operation || "EQUALS"
              });
            } else {
              arr.push({
                nombre: pathName,
                valor: false,
                operacion: c.filtro.operation || "EQUALS"
              });
            }
          }
        } else {

          if (!!c.filtro.vacio || !!c.filtro.relleno) {
            arr.push(
              {
                nombre: (c.tipo == "LISTA" ? self.getCleanPathName(c.pathName) + ".0" : pathName),
                valor: true,
                operacion: !!c.filtro.vacio ? "NOT_EXISTS" : "EXISTS",
                subOperation: c.filtro.subOperation,
                function: c.filtro.function
              }
            );
          }
          else {
            arr.push({
              nombre: pathName,
              valor: c.filtro.valor,
              operacion: c.filtro.operation,
              subOperation: c.filtro.subOperation,
              function: c.filtro.function
            });
          }
        }
        return arr;
      });
      var funcionesAgregadas = self.getActiveAgregaciones();
      return [conds, filterAndList, funcionesAgregadas];
    },
    getProjectionFields: function(conds) {
      const self = this;
      try {
        const mapProjectionFields = self.getProjectionMapColumns();
        var projections = [...self.shownFields, ...self.getProjectionsColumns().filter(c => !!c.opciones && !!c.opciones.columnaId).map(c => self.getCleanPathName(c.opciones.columnaId)), ...self.getCondsProjection(conds), ...self.getProjectionsColumns().map(c => self.getCleanPathName(c.opciones?.projectionPathName || c.pathName)), ...self.getProjectionsColumns().filter(c => !!c.opciones && !!c.opciones.prefixPathName).map(c => self.getCleanPathName(c.opciones.prefixPathName)), ...self.getProjectionFiltersColumns(), ...self.getProjectionAgregacionesColumns(), ...self.getOrderProjection().map(c => self.getCleanPathName(c)), ...mapProjectionFields];
        projections = projections.filter((item, index) => projections.indexOf(item) === index);
        // Filtrar valores vacíos
        projections = projections.filter(p => p && String(p).trim().length > 0);
        const projectionString = projections.join(",");
        console.log("[MAP DEBUG] getProjectionFields", {
          projectionLength: projections.length,
          mapProjectionFields,
          projectionString
        });
        return projectionString;
      } catch (e) {
        console.error('[PROJECTION ERROR] getProjectionFields failed:', e);
        // Fallback: retornar proyección básica por defecto
        return (self.shownFields || []).join(",");
      }
    },
    getProjectionMapColumns: function() {
      const self = this;
      try {
        const mapa = self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa;
        if (!mapa || !mapa.habilitado) {
          return [];
        }

        let mapFields = [];

        // Si hay un array de direcciones, extraer campos de todas ellas
        if (Array.isArray(mapa.direcciones)) {
          mapa.direcciones.forEach((dir, dirIdx) => {
            try {
              if (dir && dir.campoLatitud) {
                const cleanField = self.getCleanPathName(dir.campoLatitud);
                if (cleanField) mapFields.push(cleanField);
              }
              if (dir && dir.campoLongitud) {
                const cleanField = self.getCleanPathName(dir.campoLongitud);
                if (cleanField) mapFields.push(cleanField);
              }
              if (dir && Array.isArray(dir.camposDireccion)) {
                mapFields = mapFields.concat(dir.camposDireccion
                  .map(c => self.getCleanPathName(c))
                  .filter(c => c)
                );
              }
            } catch (dirError) {
              console.warn(`[MAP WARNING] Error procesando dirección ${dirIdx}:`, dirError);
            }
          });
        } else {
          // Compatibilidad: si no hay array de direcciones, usar los campos antiguos
          if (mapa.campoLatitud) {
            const cleanField = self.getCleanPathName(mapa.campoLatitud);
            if (cleanField) mapFields.push(cleanField);
          }
          if (mapa.campoLongitud) {
            const cleanField = self.getCleanPathName(mapa.campoLongitud);
            if (cleanField) mapFields.push(cleanField);
          }
          if (Array.isArray(mapa.camposDireccion)) {
            mapFields = mapFields.concat(mapa.camposDireccion
              .map(c => self.getCleanPathName(c))
              .filter(c => c)
            );
          }
        }

        // Campos adicionales que siempre se cargan
        if (mapa.campoTitulo) {
          const cleanField = self.getCleanPathName(mapa.campoTitulo);
          if (cleanField) mapFields.push(cleanField);
        }

        if (mapa.direccionCompuesta && Array.isArray(mapa.direccionCompuesta.campos)) {
          mapFields = mapFields.concat(mapa.direccionCompuesta.campos
            .map(c => self.getCleanPathName(c))
            .filter(c => c)
          );
        }

        if (Array.isArray(mapa.camposPopup)) {
          mapa.camposPopup.forEach((campoPopup, popupIdx) => {
            try {
              if (campoPopup && campoPopup.campo) {
                const cleanField = self.getCleanPathName(campoPopup.campo);
                if (cleanField) mapFields.push(cleanField);
              }
              if (campoPopup && campoPopup.compuesto && Array.isArray(campoPopup.campos)) {
                mapFields = mapFields.concat(campoPopup.campos
                  .map(c => self.getCleanPathName(c))
                  .filter(c => c)
                );
              }
            } catch (popupError) {
              console.warn(`[MAP WARNING] Error procesando popup ${popupIdx}:`, popupError);
            }
          });
        }

        return mapFields.filter((item, index) => mapFields.indexOf(item) === index);
      } catch (e) {
        console.error('[MAP ERROR] getProjectionMapColumns failed:', e);
        return [];
      }
    },
    getProjectionFieldsForMapOnly: function() {
      const self = this;
      // Proyección optimizada SOLO para el mapa: campos mapa + IDs para acciones
      let projections = [...self.getProjectionMapColumns(), ...self.getMapFilterColumns().map(column => self.getCleanPathName((column.filtro && column.filtro.pathName) || column.pathName)).filter(pathName => pathName)];
      
      // Agregar campos primarios (generalmente IDs)
      if (self.primary && Array.isArray(self.primary)) {
        projections = projections.concat(self.primary.map(p => self.getCleanPathName(p)));
      }
      
      // Agregar campos necesarios para popupActionsRenderer
      // Necesitamos varios campos de cada objeto para asegurar que se construya correctamente
      const commonIdFields = [
        'id', 
        'pedidoResumen._id',
        'pedidoResumen.id', 
        'pedidoResumen.numero',
        'pedidoResumen.codigo',
        'lineaResumen.idExpediente',
        'lineaResumen.numero',
        'lineaResumen.expedienteManual'
      ];
      projections = projections.concat(commonIdFields);
      
      // Eliminar duplicados
      projections = projections.filter((item, index) => projections.indexOf(item) === index);
      
      const projectionString = projections.join(",");
      console.log("[MAP] getProjectionFieldsForMapOnly", {
        fieldsCount: projections.length,
        fields: projectionString
      });
      return projectionString;
    },
    getProjectionFiltersColumns: function() {
      const self = this;
      return self.getProjectionsColumns().filter(c => c.filtro && c.filtro.operation && c.filtro.activo && !c.filtro.disableProjection && c.filtro.pathName).map(c => self.getCleanPathName(c.filtro.pathName));
    },
    getProjectionAgregacionesColumns: function() {
      const self = this;
      return self.getActiveAgregaciones().filter(c => !c.disableProjection).map(c => self.getCleanPathName(c.field));
    },
    getOrderProjection: function() {
      const self = this;
      const columnOrder = self.columns.filter(c => c.pathName == self.order);
      if (columnOrder && columnOrder.length) {
        return columnOrder.filter(c => !c.disableProjection).map(c => c.pathName).filter(p => p);
      } else {
        return self.order ? [self.order] : ['creationDate'];
      }
    },
    getCondsProjection: function(conds) {
      const self = this;
      if(!conds || !conds.andList) return [];
      return conds.andList.filter(cond => {
        const columnOrder = self.columns.filter(c => !c.disableProjection && c.pathName == cond.nombre);
        return columnOrder && columnOrder.length;
      }).map(cond => cond.nombre).filter(n => n);
    },
    getRemoteData: function(conAgregaciones) {
      var self = this;
      var app = self.$f7;
      var $content = self.$$(self.$el).find(".ptr-content");
      cerrojoDeLaSesion(self, 'loadingInfinite');
      // La carga que releva a otra le quita su espera, como hacía el `hide` de antes: si la vieja
      // no contestara nunca, su testigo dejaría la tabla tapada aunque la nueva ya hubiera acabado.
      // Y la vieja, al contestar, solo puede soltar la suya, que ya no está.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      if (self.$_esperaDeLaCarga) self.$_esperaDeLaCarga.cerrar();
      self.$_esperaDeLaCarga = espera;
      self.searched = true;
      var params = self.paramsGetRemoteData();

      // La página que se está pidiendo, guardada ANTES de que las ramas de abajo la decrementen
      // cuando la respuesta viene vacía. Viaja en el evento `load` (ver `consultaPedida`) porque
      // quien lo escucha no puede distinguir la primera página leyendo `self.page`: con un filtro
      // sin resultados ya vale 0.
      // `const` y no `var` aunque el resto del método vaya en `var`: Sonar marca S3504 en CRITICAL
      // en cualquier línea nueva.
      const paginaPedida = self.page;

      // Validar proyección
      if (!params || !params.projection || typeof params.projection !== 'string') {
        console.error('[SEARCH ERROR] params o params.projection es inválido:', {
          paramsExists: !!params,
          projection: params && params.projection,
          type: params && typeof params.projection
        });
        params = params || {};
        params.projection = (self.shownFields || []).join(",");
      }
      
      params.filter.withoutAggregations = true;
      params.filter.onlyAggregations = false;
      params.filter.useView = self.useView;
      params.filter = self.beforeSearch(params.filter);

      // El contexto de ESTA consulta —filtro y proyección— copiado aquí, justo antes de lanzarla.
      // Viaja en el evento `load` para que quien cuente algo sobre las filas lo cuente sobre la
      // MISMA consulta que las ha traído, en vez de volver a leer las condiciones de la pantalla
      // cuando llega la respuesta: si se ha cambiado de filtro mientras cargaba, esas condiciones
      // ya son otras y el número saldría de un conjunto distinto al que se está viendo.
      //
      // El filtro se COPIA en vez de pasarse tal cual porque la rama de sumatorios de más abajo le
      // da la vuelta a `withoutAggregations`/`onlyAggregations` sobre este mismo objeto.
      //
      // Y con la IDENTIDAD de la consulta a la que pertenece esta página, que es lo que permite
      // tirar la respuesta si al llegar ya hay otra búsqueda en marcha (ver `respuestaObsoleta`).
      // Se lee aquí, al lanzar: en el scroll infinito vale lo mismo que al pedir la primera página
      // —no se ha vaciado la tabla por medio—, así que sus páginas se conservan.
      const consultaPedida = {
        id: self.consultaVigente,
        page: paginaPedida,
        filter: Object.assign({}, params.filter),
        projection: params.projection
      };
      if (self.sendToSAP) {
        self.sendToSAP = false;
        self.dbAdapter
        .sendToSAP(params)
          .then(function(res) {
            app.dialog.alert("OK");
          })
          .catch(function(e) {
            if (typeof e == "string") e = { error: e };
            let error = e.message || e.error || e.error_description;
            app.dialog.alert(error);
            self.page = self.page - 1;
            self.nomore = true;
          })
          .then(function() {
            app.ptr.done($content);
            self.loadingInfinite = false;
            self.loadingPtr = false;
            espera.cerrar();
          });
          return;
      }
      if (self.tipoConsultasEstaticas) {
        if(self.tableUse) {
          self.consultaCargando = consultaPedida.id;
          self.Tabla.consulta(self.tableUse.codigo, params.filter).then(res => {
            if (self.$refs.popupPrefiltros) {
              self.$refs.popupPrefiltros.close();
            }
            const mapa = self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa;
            if (mapa && mapa.habilitado) {
              // Obtener campos de latitud/longitud: desde array de direcciones o legacy
              let campoLatitud = mapa.campoLatitud;
              let campoLongitud = mapa.campoLongitud;
              if (!campoLatitud && Array.isArray(mapa.direcciones) && mapa.direcciones[0]) {
                campoLatitud = mapa.direcciones[0].campoLatitud;
                campoLongitud = mapa.direcciones[0].campoLongitud;
              }
              const sample = (res.list || []).slice(0, 3).map((item, idx) => ({
                idx,
                lat: Utils.getNestedProperty(item, campoLatitud),
                lng: Utils.getNestedProperty(item, campoLongitud)
              }));
              console.log("[MAP DEBUG] getRemoteData.response.static", {
                total: (res.list || []).length,
                sample
              });
            }
            // Lo primero, antes de tocar filas, página, `nomore` o emitir `load`: si ya hay otra
            // búsqueda en marcha, esta respuesta no es de nadie.
            if (self.respuestaObsoleta(consultaPedida)) {
              return;
            }
            if (!res.list.length) {
              self.count = 0;
              self.page = self.page - 1;
              self.nomore = true;
            } else {
              self.count = res.totalCount;
              self.load(res.list);
            }
            self.$emit("load", consultaPedida);
          }).catch(function(e) {
            if (self.respuestaObsoleta(consultaPedida)) {
              return;
            }
            if (typeof e == "string") e = { error: e };
            let error = e.message || e.error || e.error_description;
            app.dialog.alert(error);
            self.page = self.page - 1;
            self.nomore = true;
            espera.cerrar();
          }).then(function() {
            app.ptr.done($content);
            // Los estados de carga sí se guardan, que son de la tabla: soltarlos mientras la
            // búsqueda nueva sigue en el aire deja entrar un tramo de scroll infinito por encima.
            // Pero SOLO si esa búsqueda nueva existe (ver `cargaVigenteEnVuelo`). El preloader NO
            // se guarda nunca: lleva la cuenta de los `show`, y su `hide` tiene que ir siempre o se
            // queda la pantalla tapada.
            if (!self.respuestaObsoleta(consultaPedida) || !self.cargaVigenteEnVuelo()) {
              self.loadingInfinite = false;
              self.loadingPtr = false;
            }
            espera.cerrar();
          });
        } else {
            self.loadingInfinite = false;
            self.loadingPtr = false;
            espera.cerrar();
        }
      } else {
        if (self.tableUse && self.tableUse.opciones && !self.tableUse.opciones.hiddenList) {
          // guardamos el tiempo actual para saber lo que ha tardado la consulta y en la respuesta rellenamos tiempoCarga
          let tiempoInicio = new Date();
          self.tiempoCarga = 0;
          self.consultaCargando = consultaPedida.id;
          self.dbAdapter
          .getList(params)
            .then(function (res) {
            self.tiempoCarga = (new Date() - tiempoInicio) / 1000;
            console.log("getList", res.list.length);
            const mapa = self.tableUse && self.tableUse.opciones && self.tableUse.opciones.mapa;
            if (mapa && mapa.habilitado) {
              // Obtener campos de latitud/longitud: desde array de direcciones o legacy
              let campoLatitud = mapa.campoLatitud;
              let campoLongitud = mapa.campoLongitud;
              if (!campoLatitud && Array.isArray(mapa.direcciones) && mapa.direcciones[0]) {
                campoLatitud = mapa.direcciones[0].campoLatitud;
                campoLongitud = mapa.direcciones[0].campoLongitud;
              }
              const sample = (res.list || []).slice(0, 3).map((item, idx) => ({
                idx,
                lat: Utils.getNestedProperty(item, campoLatitud),
                lng: Utils.getNestedProperty(item, campoLongitud)
              }));
              console.log("[MAP DEBUG] getRemoteData.response", {
                total: (res.list || []).length,
                sample
              });
            }
            // Lo primero, antes de tocar filas, página, `nomore` o emitir `load`: si ya hay otra
            // búsqueda en marcha, esta respuesta no es de nadie. Y es justo aquí donde se veía: la
            // respuesta vieja no sustituye las filas, `addData` las concatena, así que la tabla
            // acababa con la unión de las dos búsquedas y el recuento con el filtro de una sola.
            if (self.respuestaObsoleta(consultaPedida)) {
              return;
            }
            if (!res.list.length) {
            self.page = self.page - 1;
            self.nomore = true;
            } else {
            self.load(res.list);
            }
            self.$emit("load", consultaPedida);
          })
          .catch(function(e) {
            if (self.respuestaObsoleta(consultaPedida)) {
              return;
            }
            if (typeof e == "string") e = { error: e };
            let error = e.message || e.error || e.error_description;
            app.dialog.alert(error);
            self.page = self.page - 1;
            self.nomore = true;
          })
          .then(function() {
            app.ptr.done($content);
            // Los estados de carga son de la tabla y se guardan mientras haya una búsqueda nueva
            // que vaya a soltarlos; el `hide` del preloader va siempre, que lleva la cuenta de los
            // `show` (ver la rama de arriba).
            if (!self.respuestaObsoleta(consultaPedida) || !self.cargaVigenteEnVuelo()) {
              self.loadingInfinite = false;
              self.loadingPtr = false;
            }
            espera.cerrar();
          });
        } else {
          // Sin listado no hay carga que esperar. Antes el indicador se quedaba puesto aquí; con
          // testigos, además, uno sin soltar no deja apagarlo a nadie más en toda la sesión.
          espera.cerrar();
        }
      
        if (conAgregaciones) {
          self.count = 0;
          self.agregacionesValor = [];
          cerrojoDeLaSesion(self, 'loadingAggregations');
          params.filter.withoutAggregations = false;
          params.filter.onlyAggregations = true;
          let tiempoInicio = new Date();
          self.tiempoCargaSumatorios = 0;
          self.dbAdapter
            .getList(params)
            .then(function (res) {
              self.tiempoCargaSumatorios = (new Date() - tiempoInicio)/1000;
              // Los sumatorios de una búsqueda sustituida tampoco pintan: el total y las funciones
              // agregadas se enseñan al lado de las filas, y serían de otro conjunto.
              if (self.respuestaObsoleta(consultaPedida)) {
                return;
              }
              self.count = res.totalCount;
              console.log("res.funcionesAgregadas", self.count);
              self.agregacionesValor = res.funcionesAgregadas || [];
            })
            .catch(function(e) {
              if (self.respuestaObsoleta(consultaPedida)) {
                return;
              }
              if (typeof e == "string") e = { error: e };
              let error = e.message || e.error || e.error_description;
              app.dialog.alert(error);
            })
            .then(function() {
              // Este sí se suelta siempre: si una búsqueda nueva no pidiera sumatorios —pasa al
              // reordenar—, guardarlo dejaría el indicador girando para siempre. Y soltarlo de más
              // no descuadra nada, porque quien los pida lo vuelve a poner.
              self.loadingAggregations = false;
            });
        }
      }
    },
    refresh: function() {
      var self = this;
      var app = self.$f7;
      var $content = self.$$(self.$el).find(".ptr-content");
      app.ptr.refresh($content);
    },
    exportExcel: function(name) {
      var self = this;
      var app = self.$f7;
      var params = self.paramsGetRemoteData();
      params.name = name;
      params.columns = self.getActiveColumns();
      params.columns.forEach(c => {
        c.nombre = self.$t(c.nombre);
        c.pathName = self.getCleanPathName(c.pathName);
      })
      // Validar que projection sea un string válido antes de hacer split
      if (params.projection && typeof params.projection === 'string') {
        params.projection = params.projection.split(",");
      } else {
        console.warn('[EXPORT] projection es inválido:', params.projection);
        params.projection = [];
      }
      params.filter.withoutAggregations = true;
      params.filter.onlyAggregations = false;
      params.filter.useView = self.useView;
      params.filter = self.beforeSearch(params.filter);
      // El `finally` no corre si la sesión cambia mientras se genera el fichero: la espera se suelta
      // sola entonces, y por el camino normal la suelta él.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      if (self.tipoConsultasEstaticas) {
        params.filter = {codigo: self.tableUse.codigo, filtros: params.filter}
        self.Tabla.exportDynamicExcel(params).finally(() => espera.cerrar());
      } else {
        self.dbAdapter.exportDynamicExcel(params).finally(() => espera.cerrar());
      }
    },
    loadAllForMap: function() {
      const self = this;
      const app = self.$f7;
      
      if (self.loadingMapData) return;
      
      cerrojoDeLaSesion(self, 'loadingMapData');
      console.log('[MAP] Cargando todos los registros para el mapa...');
      
      // Obtener los parámetros de búsqueda actual
      var [conds, filterAndList, funcionesAgregadas] = self.getFilterAndList();
      if (!!filterAndList && !!filterAndList.length) {
        conds.andList = filterAndList;
      }
      if (!!funcionesAgregadas && !!funcionesAgregadas.length) {
        conds.funcionesAgregadas = funcionesAgregadas;
      }
      
      // Parámetros sin paginación: limit 10000 para obtener todos
      let params = {
        filter: {
          ...conds,
          paginationFilterSort: false,
          primary: self.primary,
        },
        limit: 100000, // Sin paginación, obtener todos
        offset: null,
        // NO incluir order/orderDir para evitar errores cuando el campo no está en la proyección del mapa
        complete: false,
        projection: self.getProjectionFieldsForMapOnly(), // SOLO campos del mapa optimizados
      };
      
      params.filter.withoutAggregations = true;
      params.filter.onlyAggregations = false; 
      params.filter.useView = self.useView;
      params.filter = self.beforeSearch(params.filter);
      
      console.log('[MAP] Parámetros de búsqueda para mapa:', {
        limit: params.limit,
        offset: params.offset,
        projection: params.projection
      });
      
      if (self.tipoConsultasEstaticas) {
        self.Tabla.consulta(self.tableUse.codigo, params.filter)
          .then(res => {
            console.log(`[MAP] Se cargaron ${(res.list || []).length} registros`);
            // Cargar en mapData, sin tocar vlData.items (que usa el listado)
            self.$set(self, 'mapData', res.list || []);
            self.syncMapFilteredData();
            self.allMapItemsLoaded = true;
          })
          .catch(e => {
            console.error('[MAP] Error cargando datos:', e);
            app.dialog.alert('Error al cargar los datos del mapa: ' + (e.message || e));
          })
          .finally(() => {
            self.loadingMapData = false;
          });
      } else {
        self.dbAdapter
          .getList(params)
          .then(res => {
            console.log(`[MAP] Se cargaron ${(res.list || []).length} registros`);
            // Cargar en mapData, sin tocar vlData.items (que usa el listado)
            self.$set(self, 'mapData', res.list || []);
            self.syncMapFilteredData();
            self.allMapItemsLoaded = true;
          })
          .catch(e => {
            console.error('[MAP] Error cargando datos:', e);
            app.dialog.alert('Error al cargar los datos del mapa: ' + (e.message || e));
          })
          .finally(() => {
            self.loadingMapData = false;
          });
      }
    },
    initRemoteData: function() {
      var self = this;
      var app = self.$f7;

      // Si cambia búsqueda/filtros/refresco del listado, el mapa debe recargar datos al volver
      self.invalidateMapDataCache('initRemoteData');

      self.page = 1;
      self.nomore = false;
      self.clearData();
      if (self._jqxhr) self._jqxhr.abort();
      cerrojoDeLaSesion(self, 'loadingPtr');
      // Sin `show` propio: `getRemoteData` enciende su espera nada más empezar, y un indicador
      // encendido aquí no tendría quién lo apagara.
      self.getRemoteData(self.tipoConsultasEstaticas ? false : !self.fromSort);
      self.fromSort = false;
    },
    // Si esta respuesta es de una consulta que ya se ha sustituido por otra. Se pregunta ANTES de
    // tocar las filas, la página, `nomore`, los estados de carga o emitir `load`: la respuesta vieja
    // no sustituye las filas, `addData` las CONCATENA en `vlData.items`, así que dejarla pasar deja
    // la tabla con la unión de dos búsquedas y cualquier cuenta sobre ellas descuadrada.
    //
    // Solo con `descartarRespuestasObsoletas`: sin la bandera devuelve `false` siempre y las demás
    // consultas del programa se comportan exactamente como hasta ahora.
    respuestaObsoleta: function(consulta) {
      const self = this;
      if (!self.descartarRespuestasObsoletas) {
        return false;
      }
      return !consulta || consulta.id !== self.consultaVigente;
    },
    // Si la consulta que está vigente ahora mismo tiene ya su propia carga lanzada. Es lo que
    // decide QUIÉN suelta `loadingPtr`/`loadingInfinite` cuando llega una respuesta obsoleta:
    // guardarlos es correcto mientras otra búsqueda vaya a soltarlos al terminar, pero la tabla se
    // puede quedar sin filas SIN lanzar otra consulta —`changeConsulta` y `onDrop` llaman a
    // `clearAll`, y ahí no hay respuesta que venga detrás—, y entonces nadie los soltaba: el
    // manejador de `ptr:refresh` sale al ver `loadingPtr`, así que la tabla se quedaba sin poder
    // buscar ni recargar hasta volver a montarla.
    cargaVigenteEnVuelo: function() {
      const self = this;
      return self.consultaCargando === self.consultaVigente;
    },
    load: function(data) {
      var self = this;
      self.addData(data);
    },
    addData: function(data) {
      var self = this;
      // vamos a añadirle a cada item un nuevo campo _id_ que será el valor de la clave primaria de la fila, que será concatenación de los valores de self.primary
      // data.forEach(d => {
      //   d._id_ = self.primary.map(p => {
      //     var namespaces = p.split(".");
      //     return self.getValorObjectByNamespaces(d, namespaces);
      //   }).join("-");
      // });
      // Añadiremos a self.vlData.items solo los elementos de data con _id_ distinto a los que ya están en self.vlData.items
      var items = self.vlData.items;
      // var ids = items.map(i => i._id_);
      // data = data.filter(d => ids.indexOf(d._id_) == -1);
      self.$set(self.vlData, "items", items.concat(data));
      // self.$set(self.vlData,"items",self.vlData.items.concat(data));
    },
    clearData: function() {
      var self = this;
      if (self.vlData.items) {
        self.$set(self.vlData, "items", []);
      }
      self.searched = false;
      // Consulta nueva: la tabla se queda sin filas y lo que venga de la anterior ya no es de
      // nadie. Esto es lo que mide `respuestaObsoleta`, y va aquí por lo mismo que el aviso de
      // abajo: es el único punto por el que la tabla se queda sin filas, así que es el único sitio
      // donde «empieza otra consulta» se puede escribir una vez. El scroll infinito no pasa por
      // aquí, y por eso sus páginas siguen siendo de la misma consulta.
      self.consultaVigente = self.consultaVigente + 1;
      // Las filas se han ido, así que todo lo que una pantalla haya calculado SOBRE esas filas
      // deja de valer: el recuento de clientes sin responsable de cobro de la #205, y cualquier
      // cosa parecida que venga después. Se avisa aquí, que es el ÚNICO punto por el que la tabla
      // se queda sin filas —la recarga (`initRemoteData`), el cambio de columnas (`clearAll`) y
      // la destrucción del componente (`beforeDestroy`) pasan todos por aquí—, y no en el `catch`
      // de `getRemoteData`: una carga que falla es solo uno de esos caminos, y avisar solo ahí
      // dejaba los demás enseñando el número viejo sobre una tabla en blanco.
      self.$emit("clear-data");
    },
    clearAll: function() {
      var self = this;
      self.clearData();
      self.order = self.sort;
      self.orderDir = self.sortDir;
      self.conditions = {};
      self.mapFilterConditions = {};
      self.selected = [];
      self.agregacionesValor = [];
      self.count = 0;
      if (self.$refs.rformMapFilters) {
        self.$refs.rformMapFilters.clear();
      }
      self.syncMapFilteredData();
    },
    setOrder: function(order) {
      var self = this;
      var app = self.$f7;
      self.order = order;
      if (self.orderDir == "DESC") {
        self.orderDir = "ASC";
      } else {
        self.orderDir = "DESC";
      }
      
      if (self.searched) {
        self.fromSort = true;
        self.refresh();
      }
    },
    setFilter: function(filter) {
      var self = this;
      var app = self.$f7;
      let parametros = self.$f7route.url.split('?')[1];
      console.log(parametros);
      if (parametros) {
        try {
          eval(parametros.replaceAll('&',';'));
          self.loadFilters(filter);
          self.$f7route.url = self.$f7route.url.split('?')[0];
        } catch(_){}
      }
      self.conditions = filter;
      //self.initRemoteData();
      self.refresh();
    },
    deleteItem: function(id, mensaje = null, removeItem = true) {
      var self = this;
      var app = self.$f7;
      self.$f7.dialog.confirm(
        mensaje || self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          self.dbAdapter
            .delete({ itemId: id })
            .then(function(res) {
              if (res) {
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
                if (removeItem) {
                  self.removeItem(id);
                }
                self.$emit("deleteItem");
              }
            })
            .catch(function(error) {
              var message = typeof error == "string" ? error : error.message;
              app.dialog.alert(message);
            });
        }
      );
    },
    removeItem: function(id) {
      var self = this;
      let idx = self.vlData.items.findIndex(
        d => d[self.primary] == id
      );
      self.vlData.items.splice(idx, 1);
    },
    customHeaderClasses: function(column) {
      const self = this;
      const pathName = column.pathName; 
      const list = !self.getFilterData() ? [] : 
        Object.entries(self.getFilterData())
        .filter(([key, value]) => !self.filtersNoCounters.includes(key) && value != null && typeof value != 'undefined' && (value != '' || typeof 'number') && (!Array.isArray(value) || (Array.isArray(value) && value.length)))
        .map(([key, value]) => {
          if (key.endsWith("Desde")) {
            key = key.substring(0, key.indexOf("Desde"));
          } else if (key.endsWith("Hasta")) {
            key = key.substring(0, key.indexOf("Hasta"));
          } else if (key.endsWith("FechaVacia") && value) {
            key = key.substring(0, key.indexOf("FechaVacia"));
          } else if (key.endsWith("FechaRellena") && value) {
            key = key.substring(0, key.indexOf("FechaRellena"));
          } else if (key.endsWith("CampoVacio") && value) {
            key = key.substring(0, key.indexOf("CampoVacio"));
          } else if (key.endsWith("CampoRelleno") && value) {
            key = key.substring(0, key.indexOf("CampoRelleno"));
          } else if (key.endsWith("BOOLEANSI") && value) {
            key = key.substring(0, key.indexOf("BOOLEANSI"));
          } else if (key.endsWith("BOOLEANNO") && value) {
            key = key.substring(0, key.indexOf("BOOLEANNO"));
          }
          return key;
        });
      var filterActive = list.indexOf(self.getFiltroPathName(column)) > -1;
      if (column.tipo == "LISTA") {
        filterActive = list.filter(l => self.getFiltroPathName(column).startsWith(l)).length > 0;
      }
      return {
        "label-cell": true,
        "sortable-cell": !column.disableOrder,
        "sortable-cell-active": self.order == pathName,
        "sortable-desc": self.orderDir == "DESC",
        "sortable-asc": self.orderDir == "ASC",
        "filter-cell": column.filtro && column.filtro.activo,
        "filter-cell-active": filterActive,
        "left-column-sticky": column.opciones && column.opciones.sticky
      };
    },
    customColumnClasses: function(column) {
      return {
        "left-column-sticky": column.opciones && column.opciones.sticky
      };
    },
    getClasses: function() {
      var self = this;
      var classes = Object.assign([], self.classList);
      if (!self.massiveActionsData) {
        // Si no hay acciones masivas sobre la tabla
        classes.push("hidden-checkboxes");
      }
      return classes;
    },

    formatearValorObjeto: function(item, column) {
      const self = this;
      var context = self.getValorOriginalItem(item, column);
      
      return self.formatear(context, 0);
    },

    formatear: function(context, profundidad) {
      const self = this;
      
      // si context tiene valor, vamos a ver si es un objeto en formato JSON
      if (typeof context == "string" && context.startsWith("{") && context.endsWith("}")) {
        try {
          context = JSON.parse(context);
        } catch (e) {
          console.error("Error parsing JSON: ", e);
        }
      }
      
      if (typeof context == "object" && context !== null) {
        // si es un objeto, vamos a formatearlo como un html metiendo retornos de carro para mejorar la legibilidad
        return Object.entries(context).map(([key, value]) => {
          if (typeof value == "object") {
            return `<strong>${key}:</strong> ${JSON.stringify(value)}`;
          } else {
            return `<strong>${key}:</strong> ${value}`;
          }
        }).join("<br>");

      }
      return context;
    },
  }
};
</script>
<style scoped>
  /* Cambio masivo progresivo: cuadro central minimizable + barra inferior persistente. */
  .cm-progreso-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    /* Por encima de backdrops de popup que puedan quedar tras cerrar el formulario. */
    z-index: 14500;
  }
  .cm-progreso-card {
    background: var(--f7-page-bg-color, #fff);
    color: var(--f7-text-color, #000);
    border-radius: 10px;
    padding: 14px 20px;
    width: 460px;
    max-width: 92%;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
    text-align: left;
  }
  .cm-progreso-titulo {
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 8px;
  }
  .cm-progreso-track {
    position: relative;
    background: #e0e0e0;
    border-radius: 6px;
    height: 20px;
    overflow: hidden;
  }
  .cm-progreso-track--fina {
    height: 4px;
    border-radius: 0;
  }
  .cm-progreso-bar {
    height: 100%;
    width: 0%;
    border-radius: 6px;
    background: #4CAF50;
    transition: width 0.3s ease;
  }
  .cm-progreso-track--fina .cm-progreso-bar {
    border-radius: 0;
  }
  /* Tiempo consumido/estimado superpuesto y centrado sobre la barra. */
  .cm-progreso-tiempo {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    color: #222;
    text-shadow: 0 0 3px rgba(255, 255, 255, 0.85);
    pointer-events: none;
  }
  .cm-progreso-fila {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .cm-progreso-pct {
    font-size: 15px;
    font-weight: bold;
  }
  .cm-progreso-acciones {
    display: flex;
    gap: 8px;
  }
  .cm-btn {
    border: none;
    border-radius: 6px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    background: var(--f7-theme-color, #007aff);
    color: #fff;
  }
  .cm-btn:disabled {
    opacity: 0.6;
    cursor: default;
  }
  .cm-btn--cancelar {
    background: #f44336;
  }
  .cm-progreso-barra-inferior {
    position: fixed;
    left: 0; right: 0; bottom: 0;
    background: var(--f7-page-bg-color, #fff);
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.15);
    z-index: 12000;
    cursor: pointer;
  }
  .cm-progreso-barra-inferior-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 12px;
    font-size: 12px;
    color: var(--f7-text-color, #333);
  }
  .cm-progreso-barra-inferior-texto {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .cm-progreso-barra-inferior-abrir {
    color: var(--f7-theme-color, #007aff);
    font-weight: bold;
    margin-left: 10px;
    flex-shrink: 0;
  }
  .columnaPunto {
    text-align: center;
  }
  button {
    color: white;
  }
  .thead-sticky {
    position: sticky;
    top: -2px;
    z-index: 19;
    /* border: 1px solid lightgrey; */
    /* border-width: 1px 0; */
  }
  .thead-sticky .line {
    height: 30px;
  }
  .thead-sticky .line .cell {
    height: 30px;
    line-height: 26px;
    padding: 2px 12px;
  }
  .virtual-list {
    height: calc(100% - 30px) !important;
    min-height: 200px;
  }
  .contenido-lista {
    max-height: 100%;
  }
  /* Un poco de aire entre filas: 28px (antes 24) con el filete de separación arriba. */
  .contenido-lista .line {
    height: 28px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.1);
    border-width: 1px 0 0;
  }
  .contenido-lista .line .cell {
    height: 29px;
    line-height: 26px;
  }
  /* Las filas son flex: las celdas van una detrás de otra con su ancho fijo, sin que los espacios
     en blanco de la plantilla sumen píxeles ni la última celda (controles/engranaje) salte a una
     segunda línea que se pisa con el contenido. */
  .line {
    display: flex;
    flex-wrap: nowrap;
    white-space: nowrap;
  }
  .line > .cell {
    flex: 0 0 auto;
  }
  .cell {
    display: inline-block;
    height: 26px;
    overflow: hidden;
    line-height: 23px;
    padding: 1px 12px;
    box-sizing: border-box;
    margin-top: -1px;
    position:relative;
  }
  .popupHeight {
    overflow: auto;
    height: calc(var(--f7-popup-tablet-height) - (var(--f7-navbar-height) + var(--f7-safe-area-top)));
  }
  .thead-sticky div.line:last-child > * {
    top: 0;
  }
  .tfoot-sticky div.line:first-child > * {
    bottom: 0;
  }
  .tfoot-sticky div.line > *,
  .thead-sticky div.line > * {
    position: -webkit-sticky !important;
    position: sticky !important;
    opacity: 1;
    z-index: 16;
    background: #fff;
  }
  .left-column-sticky {
    left: 0;
  }
  .right-column-sticky {
    right: 0;
  }
  .left-column-sticky,
  .right-column-sticky {
    position: -webkit-sticky !important;
    position: sticky !important;
    opacity: 1;
    z-index: 17 !important;
    background: #f7f7f8;
  }
  .table-content {
    overflow-x: auto;
  }
  .thead-sticky div.line > *.left-column-sticky,
  .thead-sticky div.line > *.right-column-sticky {
    z-index: 18 !important;
  }
</style>
<style>

.data-table .filter-cell .filter-icon i {
  top: 3px;
}
.data-table .filter-cell:not(.filter-cell-active) .filter-icon i {
  /* color: lightsteelblue; */
  color: lightgray;
}

.data-table .filter-cell:not(.filter-cell-active) .filter-icon-delete i {
  /* color: lightsteelblue; */
  visibility: hidden;
}
.data-table .filter-cell .filter-icon-delete i {
  /* color: lightsteelblue; */
  color: red;
  font-size: small;
  margin-bottom: 10px;
}
.map-filter-popover {
  width: 360px;
  max-width: calc(100vw - 32px);
}
.map-filter-popover .popover-inner {
  overflow: hidden;
}
.map-filter-popover .list {
  margin: 0;
  overflow-x: hidden;
}
.map-filter-popover .item-content,
.map-filter-popover .item-inner,
.map-filter-popover .item-input-wrap,
.map-filter-popover .input,
.map-filter-popover textarea,
.map-filter-popover input {
  max-width: 100%;
  box-sizing: border-box;
}
.badge-filtros span.badge {
  height: auto;
  max-height: 100px;
  overflow-y: auto;
  width: 100%;
}

/* Estilos para el toast de progreso de actualización masiva */
.toast-progress-massive .toast-content {
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.98);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  min-width: 300px;
}

.toast-progress-massive .toast-text {
  color: #333;
  font-size: 14px;
}

/* Animación suave para el círculo de progreso */
#progress-circle {
  transition: stroke-dashoffset 0.3s ease, stroke 0.3s ease;
}

</style>
<style scoped>
.data-table div.line.trclicked, .data-table div.line:hover {
  background-color: #746f6f5e !important;
}
.aggregation-div {
  width: 80%;
  max-height: 100px;
  overflow-y: auto;
}
.row-aggregation {
  justify-content: flex-start;
}
.subindice {
  font-size: 10px;
}
.list-columnas {
  max-height: 250px;
  overflow-y: auto;
}
.map-filters-actions {
  align-items: center;
}
.map-filters-compact {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.map-filter-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  border: 1px solid #d9d9d9;
  border-radius: 999px;
  background: #f8f9fb;
  max-width: 240px;
}
.map-filter-chip-active {
  background: #eef6ff;
  border-color: #7bb2ff;
}
.map-filter-chip-label {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.map-filter-chip-icon,
.map-filter-chip-clear {
  min-width: 20px;
}
.map-filter-chip-icon-active {
  color: #007aff;
}
.map-filter-chip-clear {
  color: #ff3b30;
}
.map-filter-popover-list {
  min-width: 340px;
  margin: 0;
}
.map-filter-popover-content {
  overflow: hidden;
}
::v-deep .map-filter-popover .navbar {
  min-height: 44px;
}
.data-table-header {
  z-index: 3000;
}
.badge-filtros {
  height: auto;
  max-height: 100px;
  overflow-y: auto;
}
.ptr-content {
  overflow: visible !important;
}
.full-height {
  display: flex;
  flex-flow: column;
  height: 100% !important;
}

.virtual-list-parent {
  overflow: auto;
}

div.cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.infinite-scroll-content {
  overflow-x: auto;
}

.hidden-checkboxes .checkbox { 
  visibility: hidden;
}

.columnaComentario {
  overflow: hidden;
  text-overflow: ellipsis;
}

.display_none {
  display: none !important;
}

.separator {
  display: inline-block;
  width: 2px;
  height: 24px; /* Ajusta la altura según sea necesario */
  background-color: #ccc; /* Ajusta el color según sea necesario */
  margin: 0 8px; /* Ajusta el espacio alrededor del separador según sea necesario */
}

/* ------------------------------------------------------------------------------------------
   Responsive. En escritorio la cabecera, el cuerpo y el pie se quedan como estaban. En tablet
   (≤1024px, donde además el menú lateral deja de estar fijo) la cabecera y el pie pasan a
   envolver en varias filas en vez de aplastarse; en móvil (≤600px) se apilan en columna y los
   combos ocupan todo el ancho. La tabla en sí sigue siendo un scroll horizontal con la columna
   de selección y la de controles pegadas a los bordes.
   ------------------------------------------------------------------------------------------ */
.consulta-autocomplete {
  min-width: 300px;
}
.map-direction-select {
  min-width: 200px;
}
.table-content {
  -webkit-overflow-scrolling: touch;
}

/* F7 da z-index:1 a cada .list, y el desplegable del combo se pinta DENTRO de su lista; cuando la
   cabecera envuelve (tablet/móvil), la lista de "Filtrar columnas", posterior en el DOM, lo tapaba. */
.consultas-list {
  z-index: 2;
}

/* Menú de la consulta favorita: los tres puntos ocupan el sitio de la "x" de borrar del combo. */
.consulta-con-menu ::v-deep .consultas-menu-trigger {
  /* El slot inner-end lo pinta F7 como hermano del input dentro de .item-inner (relative), así que
     se ancla por abajo: relleno del item + media altura del input = centro vertical del input. */
  position: absolute;
  /* Mismo `right` que da app.css al .input-suffix-btn en tablet (≤1024px); en escritorio la regla
     global lo deja a 0 y el icono se salía del borde del combo. */
  right: 20px;
  top: auto;
  bottom: calc(var(--f7-list-item-padding-vertical, 8px) + var(--f7-input-height, 36px) / 2);
  margin-right: 0;
  margin-top: 0;
  transform: translateY(50%);
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--f7-theme-color, #007aff);
}
.consulta-con-menu ::v-deep .consultas-menu-trigger .icon {
  font-size: 22px;
}
.consulta-con-menu ::v-deep input {
  padding-right: 30px;
}
.popover-consultas ::v-deep .list {
  margin: 0;
}

/* Celdas de controles (engranaje de columnas y acciones de línea): solo llevan iconos, así que el
   "…" de desbordamiento no aporta nada y, con la columna estrecha, asomaba junto al icono. */
div.controls-cell,
.thead-sticky .line .controls-cell {
  text-overflow: clip;
  padding-left: 4px;
  padding-right: 4px;
}

/* Las acciones agrupadas por línea (icono único + panel flotante) viven en rAccionesAgrupadas. */
/* La tarjeta es una columna flex y el contenido pide el 100% de alto, así que cabecera y pie se
   encogían por debajo de lo que miden (su min-height explícito anula el mínimo automático) y lo
   que sobresalía pisaba la fila de columnas. El que tiene que encoger es el contenido, que hace scroll. */
.data-table .card-header,
.data-table .card-footer {
  flex-shrink: 0;
}

@media (max-width: 1024px) {
  .card-header {
    height: auto;
  }
  /* Misma especificidad que la regla de Framework7 (.data-table .card-header > .data-table-header),
     que fija height: 100% y hacía que al envolver se saliera de la cabecera y pisara la tabla. */
  .data-table .card-header > .data-table-header,
  .data-table-header {
    flex-wrap: wrap;
    row-gap: 4px;
    height: auto;
    /* La tarjeta ya pone 10px arriba y abajo; el relleno propio de la cabecera solo resta altura
       a la tabla, que en un móvil apaisado es lo que escasea. */
    padding-top: 0;
    padding-bottom: 0;
  }
  /* Los enlaces dejan de ocupar el 100% para que las acciones se queden en la misma fila si caben,
     y los hijos no se encogen (el enlace "Nuevo ..." no se parte en dos líneas): si no caben, envuelven. */
  .data-table-links {
    width: auto;
    flex: 1 1 auto;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 4px;
    min-width: 0;
  }
  .data-table-links > * {
    flex-shrink: 0;
    white-space: nowrap;
  }
  /* El "Filtrar columnas" sí puede encoger para caber en la primera fila. */
  .data-table-links > .list {
    flex: 0 1 auto;
    min-width: 160px;
  }
  .data-table-actions {
    flex-wrap: wrap;
    row-gap: 4px;
  }
  .consulta-autocomplete {
    min-width: 220px;
  }
  /* Con la letra grande de tablet (--f7-card-font-size: 22px) los iconos de filtro, alineados a la
     línea base, empujaban el nombre de la columna fuera de la celda y se veía cortado por abajo. */
  .thead-sticky .line .cell > a.link {
    vertical-align: middle;
  }
  /* Los nombres de columna no necesitan la letra grande de tablet: se quedan como en escritorio. */
  .thead-sticky .line .cell {
    font-size: var(--f7-font-size, 14px);
  }
  .thead-sticky .line .cell > a.link ::v-deep i {
    margin-bottom: 0;
  }
  .data-table-header .list {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  /* Pie: el recuento no se parte y las agregaciones se reparten el ancho que quede. */
  .card-footer {
    flex-wrap: wrap;
    height: auto;
    row-gap: 4px;
    column-gap: 8px;
  }
  .card-footer > span:first-child {
    white-space: nowrap;
    flex-shrink: 0;
  }
  .aggregation-div {
    width: auto;
    flex: 1 1 0%;
    min-width: 0;
  }
  .card-footer > .label-cell {
    flex-shrink: 0;
  }
}

@media (max-width: 600px) {
  .data-table-header {
    flex-direction: column;
    align-items: stretch;
  }
  .data-table-links {
    flex-direction: column;
    align-items: stretch;
  }
  .data-table-links > * {
    white-space: normal;
  }
  .data-table-links > .margin-left,
  .data-table-links > .list.margin-left {
    margin-left: 0 !important;
  }
  /* Combo de consultas a todo el ancho con sus iconos (guardar/eliminar/compartir) a su derecha. */
  .data-table-links .data-table-actions {
    margin-left: 0;
    width: 100%;
    flex-wrap: nowrap;
  }
  .data-table-links .data-table-actions > .list {
    flex: 1 1 auto;
    min-width: 0;
  }
  .consulta-autocomplete,
  .map-direction-select {
    min-width: 0;
    width: 100%;
  }
  .data-table-header > .data-table-actions {
    margin-left: 0;
    justify-content: center;
  }
  .data-table-header > .data-table-actions .separator {
    display: none;
  }
  .map-filter-chip {
    max-width: 100%;
  }
  .map-filter-popover-list {
    min-width: 0;
  }
  /* Celdas algo más apretadas para que quepan más columnas en pantalla. */
  .cell {
    padding-left: 8px;
    padding-right: 8px;
  }
  /* Filas un poco más altas: con la letra grande del tema y el icono de acciones (24px) la fila de
     24px recortaba los tres puntos. */
  .contenido-lista .line {
    height: 30px;
  }
  .contenido-lista .line .cell {
    height: 32px;
    line-height: 29px;
  }
  .thead-sticky .line .cell {
    padding-left: 8px;
    padding-right: 8px;
  }
  /* El hueco del engranaje de agregaciones viene fijado en línea a 7em; en móvil no cabe. */
  .card-footer > .label-cell {
    width: auto !important;
  }
}

/* Los popups solo tienen la altura "tablet" (630px) cuando la pantalla mide al menos 630x630; en el
   resto (móvil, o tablet/móvil apaisados) el popup va a pantalla completa y la lista interior tiene
   que medir lo que mida la pantalla, no los 630px fijos. */
@media (max-width: 629px), (max-height: 629px) {
  .popupHeight {
    height: calc(100vh - (var(--f7-navbar-height) + var(--f7-safe-area-top)));
  }
}
</style>
